export const MATERIAL_ICONS = [
  {
    group: 'Action',
    icons: [
      {key: 'search', caption: 'Search'},
      {key: 'home', caption: 'Home'},
      {key: 'account_circle', caption: 'Account Circle'},
      {key: 'settings', caption: 'Settings'},
      {key: 'done', caption: 'Done'},
      {key: 'info', caption: 'Info'},
      {key: 'check_circle', caption: 'Check Circle'},
      {key: 'delete', caption: 'Delete'},
      {key: 'visibility', caption: 'Visibility'},
      {key: 'shopping_cart', caption: 'Shopping Cart'},
      {key: 'favorite', caption: 'Favorite'},
      {key: 'description', caption: 'Description'},
      {key: 'logout', caption: 'Logout'},
      {key: 'favorite_border', caption: 'Favorite Border'},
      {key: 'lock', caption: 'Lock'},
      {key: 'schedule', caption: 'Schedule'},
      {key: 'language', caption: 'Language'},
      {key: 'help_outline', caption: 'Help Outline'},
      {key: 'face', caption: 'Face'},
      {key: 'manage_accounts', caption: 'Manage Accounts'},
      {key: 'verified', caption: 'Verified'},
      {key: 'filter_alt', caption: 'Filter Alt'},
      {key: 'thumb_up', caption: 'Thumb Up'},
      {key: 'event', caption: 'Event'},
      {key: 'fingerprint', caption: 'Fingerprint'},
      {key: 'dashboard', caption: 'Dashboard'},
      {key: 'list', caption: 'List'},
      {key: 'login', caption: 'Login'},
      {key: 'visibility_off', caption: 'Visibility Off'},
      {key: 'check_circle_outline', caption: 'Check Circle Outline'},
      {key: 'calendar_today', caption: 'Calendar Today'},
      {key: 'highlight_off', caption: 'Highlight Off'},
      {key: 'help', caption: 'Help'},
      {key: 'paid', caption: 'Paid'},
      {key: 'task_alt', caption: 'Task Alt'},
      {key: 'question_answer', caption: 'Question Answer'},
      {key: 'date_range', caption: 'Date Range'},
      {key: 'article', caption: 'Article'},
      {key: 'open_in_new', caption: 'Open In New'},
      {key: 'shopping_bag', caption: 'Shopping Bag'},
      {key: 'lightbulb', caption: 'Lightbulb'},
      {key: 'credit_card', caption: 'Credit Card'},
      {key: 'perm_identity', caption: 'Perm Identity'},
      {key: 'history', caption: 'History'},
      {key: 'trending_up', caption: 'Trending Up'},
      {key: 'account_balance', caption: 'Account Balance'},
      {key: 'delete_outline', caption: 'Delete Outline'},
      {key: 'verified_user', caption: 'Verified User'},
      {key: 'fact_check', caption: 'Fact Check'},
      {key: 'report_problem', caption: 'Report Problem'},
      {key: 'assignment', caption: 'Assignment'},
      {key: 'star_rate', caption: 'Star Rate'},
      {key: 'arrow_right_alt', caption: 'Arrow Right Alt'},
      {key: 'account_balance_wallet', caption: 'Account Balance Wallet'},
      {key: 'autorenew', caption: 'Autorenew'},
      {key: 'build', caption: 'Build'},
      {key: 'view_list', caption: 'View List'},
      {key: 'calendar_month', caption: 'Calendar Month'},
      {key: 'store', caption: 'Store'},
      {key: 'print', caption: 'Print'},
      {key: 'work', caption: 'Work'},
      {key: 'analytics', caption: 'Analytics'},
      {key: 'delete_forever', caption: 'Delete Forever'},
      {key: 'today', caption: 'Today'},
      {key: 'admin_panel_settings', caption: 'Admin Panel Settings'},
      {key: 'lock_open', caption: 'Lock Open'},
      {key: 'watch_later', caption: 'Watch Later'},
      {key: 'grade', caption: 'Grade'},
      {key: 'update', caption: 'Update'},
      {key: 'savings', caption: 'Savings'},
      {key: 'room', caption: 'Room'},
      {key: 'code', caption: 'Code'},
      {key: 'add_shopping_cart', caption: 'Add Shopping Cart'},
      {key: 'contact_support', caption: 'Contact Support'},
      {key: 'receipt', caption: 'Receipt'},
      {key: 'power_settings_new', caption: 'Power Settings New'},
      {key: 'done_all', caption: 'Done All'},
      {key: 'pets', caption: 'Pets'},
      {key: 'explore', caption: 'Explore'},
      {key: 'bookmark', caption: 'Bookmark'},
      {key: 'account_box', caption: 'Account Box'},
      {key: 'note_add', caption: 'Note Add'},
      {key: 'reorder', caption: 'Reorder'},
      {key: 'pending_actions', caption: 'Pending Actions'},
      {key: 'bookmark_border', caption: 'Bookmark Border'},
      {key: 'shopping_basket', caption: 'Shopping Basket'},
      {key: 'payment', caption: 'Payment'},
      {key: 'launch', caption: 'Launch'},
      {key: 'drag_indicator', caption: 'Drag Indicator'},
      {key: 'supervisor_account', caption: 'Supervisor Account'},
      {key: 'touch_app', caption: 'Touch App'},
      {key: 'pending', caption: 'Pending'},
      {key: 'zoom_in', caption: 'Zoom In'},
      {key: 'assessment', caption: 'Assessment'},
      {key: 'leaderboard', caption: 'Leaderboard'},
      {key: 'thumb_up_off_alt', caption: 'Thumb Up Off Alt'},
      {key: 'open_in_full', caption: 'Open In Full'},
      {key: 'preview', caption: 'Preview'},
      {key: 'done_outline', caption: 'Done Outline'},
      {key: 'exit_to_app', caption: 'Exit To App'},
      {key: 'assignment_ind', caption: 'Assignment Ind'},
      {key: 'published_with_changes', caption: 'Published With Changes'},
      {key: 'card_giftcard', caption: 'Card Giftcard'},
      {key: 'view_in_ar', caption: 'View In Ar'},
      {key: 'feedback', caption: 'Feedback'},
      {key: 'work_outline', caption: 'Work Outline'},
      {key: 'timeline', caption: 'Timeline'},
      {key: 'label', caption: 'Label'},
      {key: 'swap_horiz', caption: 'Swap Horiz'},
      {key: 'tips_and_updates', caption: 'Tips And Updates'},
      {key: 'stars', caption: 'Stars'},
      {key: 'assignment_turned_in', caption: 'Assignment Turned In'},
      {key: 'dns', caption: 'Dns'},
      {key: 'sync_alt', caption: 'Sync Alt'},
      {key: 'flight_takeoff', caption: 'Flight Takeoff'},
      {key: 'space_dashboard', caption: 'Space Dashboard'},
      {key: 'contact_page', caption: 'Contact Page'},
      {key: 'book', caption: 'Book'},
      {key: 'bug_report', caption: 'Bug Report'},
      {key: 'cached', caption: 'Cached'},
      {key: 'alarm', caption: 'Alarm'},
      {key: 'translate', caption: 'Translate'},
      {key: 'gavel', caption: 'Gavel'},
      {key: 'pan_tool', caption: 'Pan Tool'},
      {key: 'edit_calendar', caption: 'Edit Calendar'},
      {key: 'supervised_user_circle', caption: 'Supervised User Circle'},
      {key: 'minimize', caption: 'Minimize'},
      {key: 'rocket_launch', caption: 'Rocket Launch'},
      {key: 'extension', caption: 'Extension'},
      {key: 'question_mark', caption: 'Question Mark'},
      {key: 'android', caption: 'Android'},
      {key: 'accessibility', caption: 'Accessibility'},
      {key: 'get_app', caption: 'Get App'},
      {key: 'record_voice_over', caption: 'Record Voice Over'},
      {key: 'add_task', caption: 'Add Task'},
      {key: 'hourglass_empty', caption: 'Hourglass Empty'},
      {key: 'help_center', caption: 'Help Center'},
      {key: 'trending_flat', caption: 'Trending Flat'},
      {key: 'accessibility_new', caption: 'Accessibility New'},
      {key: 'rule', caption: 'Rule'},
      {key: 'thumb_down', caption: 'Thumb Down'},
      {key: 'sticky_note_2', caption: 'Sticky Note 2'},
      {key: 'ads_click', caption: 'Ads Click'},
      {key: 'settings_applications', caption: 'Settings Applications'},
      {key: 'source', caption: 'Source'},
      {key: 'find_in_page', caption: 'Find In Page'},
      {key: 'dashboard_customize', caption: 'Dashboard Customize'},
      {key: 'support', caption: 'Support'},
      {key: 'flutter_dash', caption: 'Flutter Dash'},
      {key: 'swap_vert', caption: 'Swap Vert'},
      {key: 'redeem', caption: 'Redeem'},
      {key: 'close_fullscreen', caption: 'Close Fullscreen'},
      {key: 'loyalty', caption: 'Loyalty'},
      {key: 'announcement', caption: 'Announcement'},
      {key: 'arrow_circle_right', caption: 'Arrow Circle Right'},
      {key: 'view_headline', caption: 'View Headline'},
      {key: 'restore', caption: 'Restore'},
      {key: 'dangerous', caption: 'Dangerous'},
      {key: 'euro_symbol', caption: 'Euro Symbol'},
      {key: 'sensors', caption: 'Sensors'},
      {key: 'group_work', caption: 'Group Work'},
      {key: 'compare_arrows', caption: 'Compare Arrows'},
      {key: 'table_view', caption: 'Table View'},
      {key: 'subject', caption: 'Subject'},
      {key: 'disabled_by_default', caption: 'Disabled By Default'},
      {key: 'currency_exchange', caption: 'Currency Exchange'},
      {key: 'privacy_tip', caption: 'Privacy Tip'},
      {key: 'nightlight_round', caption: 'Nightlight Round'},
      {key: 'https', caption: 'Https'},
      {key: 'toc', caption: 'Toc'},
      {key: 'bookmarks', caption: 'Bookmarks'},
      {key: 'arrow_circle_up', caption: 'Arrow Circle Up'},
      {key: 'track_changes', caption: 'Track Changes'},
      {key: 'input', caption: 'Input'},
      {key: 'copyright', caption: 'Copyright'},
      {key: 'view_module', caption: 'View Module'},
      {key: 'api', caption: 'Api'},
      {key: 'grading', caption: 'Grading'},
      {key: 'perm_media', caption: 'Perm Media'},
      {key: 'query_builder', caption: 'Query Builder'},
      {key: 'build_circle', caption: 'Build Circle'},
      {key: 'perm_contact_calendar', caption: 'Perm Contact Calendar'},
      {key: 'zoom_out', caption: 'Zoom Out'},
      {key: 'settings_phone', caption: 'Settings Phone'},
      {key: 'backup', caption: 'Backup'},
      {key: 'open_with', caption: 'Open With'},
      {key: 'circle_notifications', caption: 'Circle Notifications'},
      {key: 'perm_phone_msg', caption: 'Perm Phone Msg'},
      {key: 'speaker_notes', caption: 'Speaker Notes'},
      {key: 'book_online', caption: 'Book Online'},
      {key: 'label_important', caption: 'Label Important'},
      {key: 'wysiwyg', caption: 'Wysiwyg'},
      {key: 'card_membership', caption: 'Card Membership'},
      {key: 'file_present', caption: 'File Present'},
      {key: 'arrow_circle_down', caption: 'Arrow Circle Down'},
      {key: 'pageview', caption: 'Pageview'},
      {key: '3d_rotation', caption: '3d Rotation'},
      {key: 'upgrade', caption: 'Upgrade'},
      {key: 'change_history', caption: 'Change History'},
      {key: 'integration_instructions', caption: 'Integration Instructions'},
      {key: 'trending_down', caption: 'Trending Down'},
      {key: 'percent', caption: 'Percent'},
      {key: 'swipe', caption: 'Swipe'},
      {key: 'class', caption: 'Class'},
      {key: 'accessible', caption: 'Accessible'},
      {key: 'g_translate', caption: 'G Translate'},
      {key: 'settings_accessibility', caption: 'Settings Accessibility'},
      {key: 'expand', caption: 'Expand'},
      {key: 'offline_bolt', caption: 'Offline Bolt'},
      {key: 'settings_backup_restore', caption: 'Settings Backup Restore'},
      {key: 'production_quantity_limits', caption: 'Production Quantity Limits'},
      {key: 'arrow_circle_left', caption: 'Arrow Circle Left'},
      {key: 'aspect_ratio', caption: 'Aspect Ratio'},
      {key: 'model_training', caption: 'Model Training'},
      {key: 'donut_large', caption: 'Donut Large'},
      {key: 'view_column', caption: 'View Column'},
      {key: 'segment', caption: 'Segment'},
      {key: 'calendar_view_month', caption: 'Calendar View Month'},
      {key: 'schedule_send', caption: 'Schedule Send'},
      {key: 'alarm_on', caption: 'Alarm On'},
      {key: 'maximize', caption: 'Maximize'},
      {key: 'bookmark_add', caption: 'Bookmark Add'},
      {key: 'thumbs_up_down', caption: 'Thumbs Up Down'},
      {key: 'settings_ethernet', caption: 'Settings Ethernet'},
      {key: 'theaters', caption: 'Theaters'},
      {key: 'view_agenda', caption: 'View Agenda'},
      {key: 'thumb_down_off_alt', caption: 'Thumb Down Off Alt'},
      {key: 'important_devices', caption: 'Important Devices'},
      {key: 'unpublished', caption: 'Unpublished'},
      {key: 'system_update_alt', caption: 'System Update Alt'},
      {key: 'invert_colors', caption: 'Invert Colors'},
      {key: 'opacity', caption: 'Opacity'},
      {key: 'commute', caption: 'Commute'},
      {key: 'open_in_browser', caption: 'Open In Browser'},
      {key: 'no_accounts', caption: 'No Accounts'},
      {key: 'addchart', caption: 'Addchart'},
      {key: 'history_toggle_off', caption: 'History Toggle Off'},
      {key: 'view_week', caption: 'View Week'},
      {key: 'shopping_cart_checkout', caption: 'Shopping Cart Checkout'},
      {key: 'youtube_searched_for', caption: 'Youtube Searched For'},
      {key: 'tour', caption: 'Tour'},
      {key: 'hide_source', caption: 'Hide Source'},
      {key: 'search_off', caption: 'Search Off'},
      {key: 'shop', caption: 'Shop'},
      {key: 'bookmark_added', caption: 'Bookmark Added'},
      {key: 'mark_as_unread', caption: 'Mark As Unread'},
      {key: 'not_started', caption: 'Not Started'},
      {key: 'plagiarism', caption: 'Plagiarism'},
      {key: 'settings_input_antenna', caption: 'Settings Input Antenna'},
      {key: 'turned_in', caption: 'Turned In'},
      {key: 'flight_land', caption: 'Flight Land'},
      {key: 'assignment_return', caption: 'Assignment Return'},
      {key: 'filter_alt_off', caption: 'Filter Alt Off'},
      {key: 'balance', caption: 'Balance'},
      {key: 'assignment_late', caption: 'Assignment Late'},
      {key: 'hotel_class', caption: 'Hotel Class'},
      {key: 'donut_small', caption: 'Donut Small'},
      {key: 'saved_search', caption: 'Saved Search'},
      {key: 'contactless', caption: 'Contactless'},
      {key: 'highlight_alt', caption: 'Highlight Alt'},
      {key: 'settings_input_component', caption: 'Settings Input Component'},
      {key: 'view_carousel', caption: 'View Carousel'},
      {key: 'view_quilt', caption: 'View Quilt'},
      {key: 'all_inbox', caption: 'All Inbox'},
      {key: 'anchor', caption: 'Anchor'},
      {key: 'settings_remote', caption: 'Settings Remote'},
      {key: 'edit_off', caption: 'Edit Off'},
      {key: 'turned_in_not', caption: 'Turned In Not'},
      {key: 'rocket', caption: 'Rocket'},
      {key: 'mediation', caption: 'Mediation'},
      {key: 'hourglass_full', caption: 'Hourglass Full'},
      {key: 'fit_screen', caption: 'Fit Screen'},
      {key: 'remove_shopping_cart', caption: 'Remove Shopping Cart'},
      {key: 'flaky', caption: 'Flaky'},
      {key: 'toll', caption: 'Toll'},
      {key: 'lock_clock', caption: 'Lock Clock'},
      {key: 'swap_horizontal_circle', caption: 'Swap Horizontal Circle'},
      {key: 'view_sidebar', caption: 'View Sidebar'},
      {key: 'terminal', caption: 'Terminal'},
      {key: 'settings_voice', caption: 'Settings Voice'},
      {key: 'event_seat', caption: 'Event Seat'},
      {key: 'online_prediction', caption: 'Online Prediction'},
      {key: 'vertical_split', caption: 'Vertical Split'},
      {key: 'lock_reset', caption: 'Lock Reset'},
      {key: 'next_plan', caption: 'Next Plan'},
      {key: 'data_exploration', caption: 'Data Exploration'},
      {key: 'pregnant_woman', caption: 'Pregnant Woman'},
      {key: 'restore_from_trash', caption: 'Restore From Trash'},
      {key: 'camera_enhance', caption: 'Camera Enhance'},
      {key: 'markunread_mailbox', caption: 'Markunread Mailbox'},
      {key: 'dynamic_form', caption: 'Dynamic Form'},
      {key: 'tab', caption: 'Tab'},
      {key: 'view_stream', caption: 'View Stream'},
      {key: 'calendar_view_week', caption: 'Calendar View Week'},
      {key: 'request_page', caption: 'Request Page'},
      {key: 'token', caption: 'Token'},
      {key: 'accessible_forward', caption: 'Accessible Forward'},
      {key: 'remove_done', caption: 'Remove Done'},
      {key: 'smart_button', caption: 'Smart Button'},
      {key: 'settings_power', caption: 'Settings Power'},
      {key: 'add_to_drive', caption: 'Add To Drive'},
      {key: 'outbox', caption: 'Outbox'},
      {key: 'card_travel', caption: 'Card Travel'},
      {key: 'try', caption: 'Try'},
      {key: 'density_medium', caption: 'Density Medium'},
      {key: 'offline_pin', caption: 'Offline Pin'},
      {key: 'add_card', caption: 'Add Card'},
      {key: 'find_replace', caption: 'Find Replace'},
      {key: 'fax', caption: 'Fax'},
      {key: 'calendar_view_day', caption: 'Calendar View Day'},
      {key: 'compress', caption: 'Compress'},
      {key: 'rowing', caption: 'Rowing'},
      {key: 'assignment_returned', caption: 'Assignment Returned'},
      {key: 'chrome_reader_mode', caption: 'Chrome Reader Mode'},
      {key: 'outlet', caption: 'Outlet'},
      {key: 'http', caption: 'Http'},
      {key: 'settings_brightness', caption: 'Settings Brightness'},
      {key: 'generating_tokens', caption: 'Generating Tokens'},
      {key: 'new_label', caption: 'New Label'},
      {key: 'work_history', caption: 'Work History'},
      {key: 'backup_table', caption: 'Backup Table'},
      {key: 'alarm_add', caption: 'Alarm Add'},
      {key: 'spellcheck', caption: 'Spellcheck'},
      {key: 'free_cancellation', caption: 'Free Cancellation'},
      {key: 'restore_page', caption: 'Restore Page'},
      {key: 'credit_card_off', caption: 'Credit Card Off'},
      {key: '123', caption: '123'},
      {key: 'play_for_work', caption: 'Play For Work'},
      {key: 'wifi_protected_setup', caption: 'Wifi Protected Setup'},
      {key: 'settings_overscan', caption: 'Settings Overscan'},
      {key: 'disabled_visible', caption: 'Disabled Visible'},
      {key: 'event_repeat', caption: 'Event Repeat'},
      {key: 'gif', caption: 'GIF'},
      {key: 'assured_workload', caption: 'Assured Workload'},
      {key: 'display_settings', caption: 'Display Settings'},
      {key: 'outbound', caption: 'Outbound'},
      {key: 'swap_vertical_circle', caption: 'Swap Vertical Circle'},
      {key: 'pan_tool_alt', caption: 'Pan Tool Alt'},
      {key: 'noise_control_off', caption: 'Noise Control Off'},
      {key: 'cancel_schedule_send', caption: 'Cancel Schedule Send'},
      {key: 'view_timeline', caption: 'View Timeline'},
      {key: 'settings_input_composite', caption: 'Settings Input Composite'},
      {key: 'quickreply', caption: 'Quickreply'},
      {key: 'switch_access_shortcut', caption: 'Switch Access Shortcut'},
      {key: 'view_day', caption: 'View Day'},
      {key: 'comment_bank', caption: 'Comment Bank'},
      {key: 'manage_history', caption: 'Manage History'},
      {key: 'line_weight', caption: 'Line Weight'},
      {key: 'satellite_alt', caption: 'Satellite Alt'},
      {key: 'webhook', caption: 'Webhook'},
      {key: 'horizontal_split', caption: 'Horizontal Split'},
      {key: 'polymer', caption: 'Polymer'},
      {key: 'batch_prediction', caption: 'Batch Prediction'},
      {key: 'send_and_archive', caption: 'Send And Archive'},
      {key: 'picture_in_picture', caption: 'Picture In Picture'},
      {key: 'code_off', caption: 'Code Off'},
      {key: 'bookmark_remove', caption: 'Bookmark Remove'},
      {key: 'settings_bluetooth', caption: 'Settings Bluetooth'},
      {key: 'output', caption: 'Output'},
      {key: 'html', caption: 'HTML'},
      {key: 'shop_two', caption: 'Shop Two'},
      {key: 'flip_to_front', caption: 'Flip To Front'},
      {key: 'troubleshoot', caption: 'Troubleshoot'},
      {key: 'gif_box', caption: 'GIF Box'},
      {key: 'eject', caption: 'Eject'},
      {key: 'speaker_notes_off', caption: 'Speaker Notes Off'},
      {key: 'alarm_off', caption: 'Alarm Off'},
      {key: 'perm_data_setting', caption: 'Perm Data Setting'},
      {key: 'settings_input_hdmi', caption: 'Settings Input Hdmi'},
      {key: 'perm_scan_wifi', caption: 'Perm Scan Wifi'},
      {key: 'hourglass_disabled', caption: 'Hourglass Disabled'},
      {key: 'switch_access_shortcut_add', caption: 'Switch Access Shortcut Add'},
      {key: 'sensors_off', caption: 'Sensors Off'},
      {key: 'work_off', caption: 'Work Off'},
      {key: 'settings_cell', caption: 'Settings Cell'},
      {key: 'app_blocking', caption: 'App Blocking'},
      {key: 'picture_in_picture_alt', caption: 'Picture In Picture Alt'},
      {key: 'line_style', caption: 'Line Style'},
      {key: 'join_full', caption: 'Join Full'},
      {key: 'perm_device_information', caption: 'Perm Device Information'},
      {key: 'javascript', caption: 'Javascript'},
      {key: 'app_shortcut', caption: 'App Shortcut'},
      {key: 'subtitles_off', caption: 'Subtitles Off'},
      {key: 'update_disabled', caption: 'Update Disabled'},
      {key: 'abc', caption: 'Abc'},
      {key: 'swipe_left', caption: 'Swipe Left'},
      {key: 'lightbulb_circle', caption: 'Lightbulb Circle'},
      {key: 'voice_over_off', caption: 'Voice Over Off'},
      {key: 'private_connectivity', caption: 'Private Connectivity'},
      {key: 'join_inner', caption: 'Join Inner'},
      {key: 'settings_input_svideo', caption: 'Settings Input Svideo'},
      {key: 'install_desktop', caption: 'Install Desktop'},
      {key: 'swipe_right', caption: 'Swipe Right'},
      {key: 'flip_to_back', caption: 'Flip To Back'},
      {key: 'swipe_up', caption: 'Swipe Up'},
      {key: 'view_array', caption: 'View Array'},
      {key: 'open_in_new_off', caption: 'Open In New Off'},
      {key: 'all_out', caption: 'All Out'},
      {key: 'arrow_outward', caption: 'Arrow Outward'},
      {key: 'shop_2', caption: 'Shop 2'},
      {key: 'density_small', caption: 'Density Small'},
      {key: 'label_off', caption: 'Label Off'},
      {key: 'tab_unselected', caption: 'Tab Unselected'},
      {key: 'data_thresholding', caption: 'Data Thresholding'},
      {key: 'rounded_corner', caption: 'Rounded Corner'},
      {key: 'commit', caption: 'Commit'},
      {key: 'text_rotate_vertical', caption: 'Text Rotate Vertical'},
      {key: 'explore_off', caption: 'Explore Off'},
      {key: 'view_kanban', caption: 'View Kanban'},
      {key: 'install_mobile', caption: 'Install Mobile'},
      {key: 'lock_person', caption: 'Lock Person'},
      {key: 'text_rotation_none', caption: 'Text Rotation None'},
      {key: 'css', caption: 'CSS'},
      {key: 'swipe_down', caption: 'Swipe Down'},
      {key: 'not_accessible', caption: 'Not Accessible'},
      {key: 'spatial_audio_off', caption: 'Spatial Audio Off'},
      {key: 'pin_invoke', caption: 'Pin Invoke'},
      {key: 'join_left', caption: 'Join Left'},
      {key: 'pinch', caption: 'Pinch'},
      {key: 'extension_off', caption: 'Extension Off'},
      {key: 'perm_camera_mic', caption: 'Perm Camera Mic'},
      {key: 'swipe_vertical', caption: 'Swipe Vertical'},
      {key: 'noise_aware', caption: 'Noise Aware'},
      {key: 'view_cozy', caption: 'View Cozy'},
      {key: 'pin_end', caption: 'Pin End'},
      {key: 'join_right', caption: 'Join Right'},
      {key: 'swipe_right_alt', caption: 'Swipe Right Alt'},
      {key: 'text_rotate_up', caption: 'Text Rotate Up'},
      {key: 'text_rotation_angledown', caption: 'Text Rotation Angledown'},
      {key: 'browse_gallery', caption: 'Browse Gallery'},
      {key: 'php', caption: 'PHP'},
      {key: 'text_rotation_angleup', caption: 'Text Rotation Angleup'},
      {key: 'text_rotation_down', caption: 'Text Rotation Down'},
      {key: 'view_comfy_alt', caption: 'View Comfy Alt'},
      {key: 'view_compact_alt', caption: 'View Compact Alt'},
      {key: 'network_ping', caption: 'Network Ping'},
      {key: 'swipe_down_alt', caption: 'Swipe Down Alt'},
      {key: 'add_home', caption: 'Add Home'},
      {key: 'unfold_more_double', caption: 'Unfold More Double'},
      {key: 'on_device_training', caption: 'On Device Training'},
      {key: 'density_large', caption: 'Density Large'},
      {key: 'swipe_left_alt', caption: 'Swipe Left Alt'},
      {key: 'spatial_tracking', caption: 'Spatial Tracking'},
      {key: 'swipe_up_alt', caption: 'Swipe Up Alt'},
      {key: 'spatial_audio', caption: 'Spatial Audio'},
      {key: 'width_full', caption: 'Width Full'},
      {key: 'unfold_less_double', caption: 'Unfold Less Double'},
      {key: 'repartition', caption: 'Repartition'},
      {key: 'width_normal', caption: 'Width Normal'},
      {key: 'transcribe', caption: 'Transcribe'},
      {key: 'width_wide', caption: 'Width Wide'},
      {key: 'hls_off', caption: 'HLS Off'},
      {key: 'hls', caption: 'HLS'},
      {
        key: 'face_unlock',
        caption: 'Face Unlock',
      },
    ],
  },
  {
    group: 'Navigation',
    icons: [
      {key: 'close', caption: 'Close'},
      {key: 'menu', caption: 'Menu'},
      {key: 'expand_more', caption: 'Expand More'},
      {key: 'arrow_back', caption: 'Arrow Back'},
      {key: 'chevron_right', caption: 'Chevron Right'},
      {key: 'arrow_forward_ios', caption: 'Arrow Forward iOS'},
      {key: 'arrow_back_ios', caption: 'Arrow Back iOS'},
      {key: 'cancel', caption: 'Cancel'},
      {key: 'arrow_drop_down', caption: 'Arrow Drop Down'},
      {key: 'more_vert', caption: 'More Vert'},
      {key: 'arrow_forward', caption: 'Arrow Forward'},
      {key: 'chevron_left', caption: 'Chevron Left'},
      {key: 'expand_less', caption: 'Expand Less'},
      {key: 'check', caption: 'Check'},
      {key: 'more_horiz', caption: 'More Horiz'},
      {key: 'refresh', caption: 'Refresh'},
      {key: 'apps', caption: 'Apps'},
      {key: 'payments', caption: 'Payments'},
      {key: 'arrow_upward', caption: 'Arrow Upward'},
      {key: 'east', caption: 'East'},
      {key: 'campaign', caption: 'Campaign'},
      {key: 'arrow_back_ios_new', caption: 'Arrow Back iOS New'},
      {key: 'arrow_downward', caption: 'Arrow Downward'},
      {key: 'arrow_right', caption: 'Arrow Right'},
      {key: 'menu_open', caption: 'Menu Open'},
      {key: 'fullscreen', caption: 'Fullscreen'},
      {key: 'arrow_drop_up', caption: 'Arrow Drop Up'},
      {key: 'unfold_more', caption: 'Unfold More'},
      {key: 'double_arrow', caption: 'Double Arrow'},
      {key: 'maps_home_work', caption: 'Maps Home Work'},
      {key: 'west', caption: 'West'},
      {key: 'expand_circle_down', caption: 'Expand Circle Down'},
      {key: 'arrow_left', caption: 'Arrow Left'},
      {key: 'south', caption: 'South'},
      {key: 'north_east', caption: 'North East'},
      {key: 'north', caption: 'North'},
      {key: 'home_work', caption: 'Home Work'},
      {key: 'first_page', caption: 'First Page'},
      {key: 'fullscreen_exit', caption: 'Fullscreen Exit'},
      {key: 'arrow_drop_down_circle', caption: 'Arrow Drop Down Circle'},
      {key: 'last_page', caption: 'Last Page'},
      {key: 'unfold_less', caption: 'Unfold Less'},
      {key: 'subdirectory_arrow_right', caption: 'Subdirectory Arrow Right'},
      {key: 'legend_toggle', caption: 'Legend Toggle'},
      {key: 'south_east', caption: 'South East'},
      {key: 'app_settings_alt', caption: 'App Settings Alt'},
      {key: 'assistant_direction', caption: 'Assistant Direction'},
      {key: 'subdirectory_arrow_left', caption: 'Subdirectory Arrow Left'},
      {key: 'north_west', caption: 'North West'},
      {key: 'waterfall_chart', caption: 'Waterfall Chart'},
      {key: 'switch_left', caption: 'Switch Left'},
      {key: 'south_west', caption: 'South West'},
      {key: 'pivot_table_chart', caption: 'Pivot Table Chart'},
      {key: 'switch_right', caption: 'Switch Right'},
      {key: 'apps_outage', caption: 'Apps Outage'},
      {key: 'offline_share', caption: 'Offline Share'},
      {
        key: 'add_home_work',
        caption: 'Add Home Work',
      },
    ],
  },
  {
    group: 'Social',
    icons: [
      {key: 'person', caption: 'Person'},
      {key: 'notifications', caption: 'Notifications'},
      {key: 'groups', caption: 'Groups'},
      {key: 'people', caption: 'People'},
      {key: 'share', caption: 'Share'},
      {key: 'school', caption: 'School'},
      {key: 'person_outline', caption: 'Person Outline'},
      {key: 'person_add', caption: 'Person Add'},
      {key: 'public', caption: 'Public'},
      {key: 'emoji_events', caption: 'Emoji Events'},
      {key: 'group', caption: 'Group'},
      {key: 'engineering', caption: 'Engineering'},
      {key: 'notifications_active', caption: 'Notifications Active'},
      {key: 'construction', caption: 'Construction'},
      {key: 'people_alt', caption: 'People Alt'},
      {key: 'group_add', caption: 'Group Add'},
      {key: 'psychology', caption: 'Psychology'},
      {key: 'thumb_up_alt', caption: 'Thumb Up Alt'},
      {key: 'health_and_safety', caption: 'Health And Safety'},
      {key: 'travel_explore', caption: 'Travel Explore'},
      {key: 'water_drop', caption: 'Water Drop'},
      {key: 'notifications_none', caption: 'Notifications None'},
      {key: 'emoji_emotions', caption: 'Emoji Emotions'},
      {key: 'sports_esports', caption: 'Sports Esports'},
      {key: 'sentiment_very_satisfied', caption: 'Sentiment Very Satisfied'},
      {key: 'location_city', caption: 'Location City'},
      {key: 'ios_share', caption: 'iOS Share'},
      {key: 'workspace_premium', caption: 'Workspace Premium'},
      {key: 'precision_manufacturing', caption: 'Precision Manufacturing'},
      {key: 'sentiment_satisfied', caption: 'Sentiment Satisfied'},
      {key: 'person_add_alt', caption: 'Person Add Alt'},
      {key: 'military_tech', caption: 'Military Tech'},
      {key: 'science', caption: 'Science'},
      {key: 'emoji_objects', caption: 'Emoji Objects'},
      {key: 'history_edu', caption: 'History Edu'},
      {key: 'cake', caption: 'Cake'},
      {key: 'sentiment_dissatisfied', caption: 'Sentiment Dissatisfied'},
      {key: 'handshake', caption: 'Handshake'},
      {key: 'sentiment_very_dissatisfied', caption: 'Sentiment Very Dissatisfied'},
      {key: 'emoji_people', caption: 'Emoji People'},
      {key: 'coronavirus', caption: 'Coronavirus'},
      {key: 'self_improvement', caption: 'Self Improvement'},
      {key: 'person_remove', caption: 'Person Remove'},
      {key: 'poll', caption: 'Poll'},
      {key: 'whatshot', caption: 'Whatshot'},
      {key: 'sports_soccer', caption: 'Sports Soccer'},
      {key: 'domain', caption: 'Domain'},
      {key: 'recommend', caption: 'Recommend'},
      {key: 'mood', caption: 'Mood'},
      {key: 'people_outline', caption: 'People Outline'},
      {key: 'female', caption: 'Female'},
      {key: 'recycling', caption: 'Recycling'},
      {key: 'person_off', caption: 'Person Off'},
      {key: 'male', caption: 'Male'},
      {key: 'person_add_alt_1', caption: 'Person Add Alt 1'},
      {key: 'connect_without_contact', caption: 'Connect Without Contact'},
      {key: 'sentiment_neutral', caption: 'Sentiment Neutral'},
      {key: 'waving_hand', caption: 'Waving Hand'},
      {key: 'back_hand', caption: 'Back Hand'},
      {key: 'thumb_down_alt', caption: 'Thumb Down Alt'},
      {key: 'hiking', caption: 'Hiking'},
      {key: 'architecture', caption: 'Architecture'},
      {key: 'notifications_off', caption: 'Notifications Off'},
      {key: 'masks', caption: 'Masks'},
      {key: 'real_estate_agent', caption: 'Real Estate Agent'},
      {key: 'luggage', caption: 'Luggage'},
      {key: 'front_hand', caption: 'Front Hand'},
      {key: 'vaccines', caption: 'Vaccines'},
      {key: 'mood_bad', caption: 'Mood Bad'},
      {key: 'emoji_nature', caption: 'Emoji Nature'},
      {key: 'switch_account', caption: 'Switch Account'},
      {key: 'compost', caption: 'Compost'},
      {key: 'nights_stay', caption: 'Nights Stay'},
      {key: 'interests', caption: 'Interests'},
      {key: 'king_bed', caption: 'King Bed'},
      {key: 'catching_pokemon', caption: 'Catching Pokemon'},
      {key: 'diversity_3', caption: 'Diversity 3'},
      {key: 'sports_basketball', caption: 'Sports Basketball'},
      {key: 'notification_add', caption: 'Notification Add'},
      {key: 'cruelty_free', caption: 'Cruelty Free'},
      {key: 'sports_kabaddi', caption: 'Sports Kabaddi'},
      {key: 'sports', caption: 'Sports'},
      {key: 'man', caption: 'Man'},
      {key: 'emoji_symbols', caption: 'Emoji Symbols'},
      {key: 'reduce_capacity', caption: 'Reduce Capacity'},
      {key: 'emoji_food_beverage', caption: 'Emoji Food Beverage'},
      {key: 'sick', caption: 'Sick'},
      {key: 'emoji_transportation', caption: 'Emoji Transportation'},
      {key: 'cookie', caption: 'Cookie'},
      {key: 'heart_broken', caption: 'Heart Broken'},
      {key: 'sports_tennis', caption: 'Sports Tennis'},
      {key: 'transgender', caption: 'Transgender'},
      {key: 'elderly', caption: 'Elderly'},
      {key: 'add_moderator', caption: 'Add Moderator'},
      {key: 'woman', caption: 'Woman'},
      {key: 'add_reaction', caption: 'Add Reaction'},
      {key: 'outdoor_grill', caption: 'Outdoor Grill'},
      {key: 'personal_injury', caption: 'Personal Injury'},
      {key: 'deck', caption: 'Deck'},
      {key: 'wallet', caption: 'Wallet'},
      {key: 'follow_the_signs', caption: 'Follow The Signs'},
      {key: 'social_distance', caption: 'Social Distance'},
      {key: 'diversity_1', caption: 'Diversity 1'},
      {key: 'plus_one', caption: 'Plus One'},
      {key: 'scale', caption: 'Scale'},
      {key: 'fireplace', caption: 'Fireplace'},
      {key: 'clean_hands', caption: 'Clean Hands'},
      {key: 'piano', caption: 'Piano'},
      {key: 'pix', caption: 'Pix'},
      {key: 'surfing', caption: 'Surfing'},
      {key: 'sports_motorsports', caption: 'Sports Motorsports'},
      {key: 'sanitizer', caption: 'Sanitizer'},
      {key: 'sports_handball', caption: 'Sports Handball'},
      {key: 'sports_baseball', caption: 'Sports Baseball'},
      {key: 'hive', caption: 'Hive'},
      {key: 'edit_notifications', caption: 'Edit Notifications'},
      {key: 'groups_2', caption: 'Groups 2'},
      {key: 'sports_volleyball', caption: 'Sports Volleyball'},
      {key: 'psychology_alt', caption: 'Psychology Alt'},
      {key: 'pages', caption: 'Pages'},
      {key: 'sports_football', caption: 'Sports Football'},
      {key: 'downhill_skiing', caption: 'Downhill Skiing'},
      {key: 'kayaking', caption: 'Kayaking'},
      {key: 'diversity_2', caption: 'Diversity 2'},
      {key: 'public_off', caption: 'Public Off'},
      {key: 'group_remove', caption: 'Group Remove'},
      {key: 'co2', caption: 'Co2'},
      {key: 'single_bed', caption: 'Single Bed'},
      {key: 'remove_moderator', caption: 'Remove Moderator'},
      {key: 'skateboarding', caption: 'Skateboarding'},
      {key: 'notifications_paused', caption: 'Notifications Paused'},
      {key: 'boy', caption: 'Boy'},
      {key: 'person_remove_alt_1', caption: 'Person Remove Alt 1'},
      {key: 'safety_divider', caption: 'Safety Divider'},
      {key: 'domain_add', caption: 'Domain Add'},
      {key: 'fitbit', caption: 'Fitbit'},
      {key: 'group_off', caption: 'Group Off'},
      {key: 'sports_cricket', caption: 'Sports Cricket'},
      {key: 'sports_mma', caption: 'Sports Mma'},
      {key: 'sports_martial_arts', caption: 'Sports Martial Arts'},
      {key: 'thunderstorm', caption: 'Thunderstorm'},
      {key: 'nordic_walking', caption: 'Nordic Walking'},
      {key: 'sports_golf', caption: 'Sports Golf'},
      {key: 'girl', caption: 'Girl'},
      {key: 'groups_3', caption: 'Groups 3'},
      {key: 'paragliding', caption: 'Paragliding'},
      {key: 'sports_gymnastics', caption: 'Sports Gymnastics'},
      {key: 'party_mode', caption: 'Party Mode'},
      {key: 'snowboarding', caption: 'Snowboarding'},
      {key: '6_ft_apart', caption: '6 Ft Apart'},
      {key: 'face_6', caption: 'Face 6'},
      {key: 'kitesurfing', caption: 'Kitesurfing'},
      {key: 'face_3', caption: 'Face 3'},
      {key: 'snowshoeing', caption: 'Snowshoeing'},
      {key: 'sports_hockey', caption: 'Sports Hockey'},
      {key: 'south_america', caption: 'South America'},
      {key: 'ice_skating', caption: 'Ice Skating'},
      {key: 'sports_rugby', caption: 'Sports Rugby'},
      {key: 'elderly_woman', caption: 'Elderly Woman'},
      {key: 'sledding', caption: 'Sledding'},
      {key: 'person_2', caption: 'Person 2'},
      {key: 'scoreboard', caption: 'Scoreboard'},
      {key: 'face_2', caption: 'Face 2'},
      {key: 'face_4', caption: 'Face 4'},
      {key: 'sign_language', caption: 'Sign Language'},
      {key: 'cyclone', caption: 'Cyclone'},
      {key: 'no_luggage', caption: 'No Luggage'},
      {key: 'face_5', caption: 'Face 5'},
      {key: 'person_4', caption: 'Person 4'},
      {key: 'person_3', caption: 'Person 3'},
      {key: 'flood', caption: 'Flood'},
      {key: 'piano_off', caption: 'Piano Off'},
      {key: 'scuba_diving', caption: 'Scuba Diving'},
      {key: 'severe_cold', caption: 'Severe Cold'},
      {key: 'tsunami', caption: 'Tsunami'},
      {key: 'roller_skating', caption: 'Roller Skating'},
      {key: 'tornado', caption: 'Tornado'},
      {key: 'landslide', caption: 'Landslide'},
      {key: 'assist_walker', caption: 'Assist Walker'},
      {key: 'woman_2', caption: 'Woman 2'},
      {key: 'man_2', caption: 'Man 2'},
      {key: 'blind', caption: 'Blind'},
      {key: '18_up_rating', caption: '18 Up Rating'},
      {key: 'volcano', caption: 'Volcano'},
      {key: 'no_adult_content', caption: 'No Adult Content'},
      {key: 'man_4', caption: 'Man 4'},
      {
        key: 'man_3',
        caption: 'Man 3',
      },
    ],
  },
  {
    group: 'Content',
    icons: [
      {key: 'add', caption: 'Add'},
      {key: 'add_circle_outline', caption: 'Add Circle Outline'},
      {key: 'content_copy', caption: 'Content Copy'},
      {key: 'add_circle', caption: 'Add Circle'},
      {key: 'send', caption: 'Send'},
      {key: 'clear', caption: 'Clear'},
      {key: 'save', caption: 'Save'},
      {key: 'mail', caption: 'Mail'},
      {key: 'link', caption: 'Link'},
      {key: 'remove', caption: 'Remove'},
      {key: 'filter_list', caption: 'Filter List'},
      {key: 'inventory_2', caption: 'Inventory 2'},
      {key: 'inventory', caption: 'Inventory'},
      {key: 'insights', caption: 'Insights'},
      {key: 'remove_circle_outline', caption: 'Remove Circle Outline'},
      {key: 'sort', caption: 'Sort'},
      {key: 'bolt', caption: 'Bolt'},
      {key: 'flag', caption: 'Flag'},
      {key: 'reply', caption: 'Reply'},
      {key: 'add_box', caption: 'Add Box'},
      {key: 'remove_circle', caption: 'Remove Circle'},
      {key: 'push_pin', caption: 'Push Pin'},
      {key: 'block', caption: 'Block'},
      {key: 'calculate', caption: 'Calculate'},
      {key: 'create', caption: 'Create'},
      {key: 'undo', caption: 'Undo'},
      {key: 'how_to_reg', caption: 'How To Reg'},
      {key: 'content_paste', caption: 'Content Paste'},
      {key: 'report', caption: 'Report'},
      {key: 'file_copy', caption: 'File Copy'},
      {key: 'backspace', caption: 'Backspace'},
      {key: 'shield', caption: 'Shield'},
      {key: 'archive', caption: 'Archive'},
      {key: 'save_alt', caption: 'Save Alt'},
      {key: 'policy', caption: 'Policy'},
      {key: 'change_circle', caption: 'Change Circle'},
      {key: 'tag', caption: 'Tag'},
      {key: 'redo', caption: 'Redo'},
      {key: 'forward', caption: 'Forward'},
      {key: 'content_cut', caption: 'Content Cut'},
      {key: 'outlined_flag', caption: 'Outlined Flag'},
      {key: 'inbox', caption: 'Inbox'},
      {key: 'link_off', caption: 'Link Off'},
      {key: 'ballot', caption: 'Ballot'},
      {key: 'drafts', caption: 'Drafts'},
      {key: 'biotech', caption: 'Biotech'},
      {key: 'report_gmailerrorred', caption: 'Report Gmailerrorred'},
      {key: 'delete_sweep', caption: 'Delete Sweep'},
      {key: 'stacked_bar_chart', caption: 'Stacked Bar Chart'},
      {key: 'markunread', caption: 'Markunread'},
      {key: 'square_foot', caption: 'Square Foot'},
      {key: 'add_link', caption: 'Add Link'},
      {key: 'stream', caption: 'Stream'},
      {key: 'copy_all', caption: 'Copy All'},
      {key: 'where_to_vote', caption: 'Where To Vote'},
      {key: 'dynamic_feed', caption: 'Dynamic Feed'},
      {key: 'move_to_inbox', caption: 'Move To Inbox'},
      {key: 'waves', caption: 'Waves'},
      {key: 'content_paste_search', caption: 'Content Paste Search'},
      {key: 'unarchive', caption: 'Unarchive'},
      {key: 'reply_all', caption: 'Reply All'},
      {key: 'select_all', caption: 'Select All'},
      {key: 'low_priority', caption: 'Low Priority'},
      {key: 'text_format', caption: 'Text Format'},
      {key: 'save_as', caption: 'Save As'},
      {key: 'font_download', caption: 'Font Download'},
      {key: 'weekend', caption: 'Weekend'},
      {key: 'how_to_vote', caption: 'How To Vote'},
      {key: 'upcoming', caption: 'Upcoming'},
      {key: 'gesture', caption: 'Gesture'},
      {key: 'attribution', caption: 'Attribution'},
      {key: 'flag_circle', caption: 'Flag Circle'},
      {key: 'content_paste_go', caption: 'Content Paste Go'},
      {key: 'filter_list_off', caption: 'Filter List Off'},
      {key: 'next_week', caption: 'Next Week'},
      {key: 'content_paste_off', caption: 'Content Paste Off'},
      {key: 'web_stories', caption: 'Web Stories'},
      {key: 'report_off', caption: 'Report Off'},
      {key: 'deselect', caption: 'Deselect'},
      {
        key: 'font_download_off',
        caption: 'Font Download Off',
      },
    ],
  },
  {
    group: 'Image',
    icons: [
      {key: 'edit', caption: 'Edit'},
      {key: 'navigate_next', caption: 'Navigate Next'},
      {key: 'photo_camera', caption: 'Photo Camera'},
      {key: 'image', caption: 'Image'},
      {key: 'tune', caption: 'Tune'},
      {key: 'picture_as_pdf', caption: 'Picture As Pdf'},
      {key: 'receipt_long', caption: 'Receipt Long'},
      {key: 'circle', caption: 'Circle'},
      {key: 'timer', caption: 'Timer'},
      {key: 'auto_stories', caption: 'Auto Stories'},
      {key: 'auto_awesome', caption: 'Auto Awesome'},
      {key: 'collections', caption: 'Collections'},
      {key: 'navigate_before', caption: 'Navigate Before'},
      {key: 'add_a_photo', caption: 'Add A Photo'},
      {key: 'palette', caption: 'Palette'},
      {key: 'remove_red_eye', caption: 'Remove Red Eye'},
      {key: 'music_note', caption: 'Music Note'},
      {key: 'add_photo_alternate', caption: 'Add Photo Alternate'},
      {key: 'wb_sunny', caption: 'Wb Sunny'},
      {key: 'brush', caption: 'Brush'},
      {key: 'euro', caption: 'Euro'},
      {key: 'flash_on', caption: 'Flash On'},
      {key: 'auto_fix_high', caption: 'Auto Fix High'},
      {key: 'looks_one', caption: 'Looks One'},
      {key: 'control_point', caption: 'Control Point'},
      {key: 'style', caption: 'Style'},
      {key: 'adjust', caption: 'Adjust'},
      {key: 'straighten', caption: 'Straighten'},
      {key: 'photo_library', caption: 'Photo Library'},
      {key: 'camera', caption: 'Camera'},
      {key: 'portrait', caption: 'Portrait'},
      {key: 'camera_alt', caption: 'Camera Alt'},
      {key: 'audiotrack', caption: 'Audiotrack'},
      {key: 'rotate_right', caption: 'Rotate Right'},
      {key: 'video_camera_front', caption: 'Video Camera Front'},
      {key: 'color_lens', caption: 'Color Lens'},
      {key: 'grid_on', caption: 'Grid On'},
      {key: 'crop_free', caption: 'Crop Free'},
      {key: 'timelapse', caption: 'Timelapse'},
      {key: 'currency_rupee', caption: 'Currency Rupee'},
      {key: 'slideshow', caption: 'Slideshow'},
      {key: 'landscape', caption: 'Landscape'},
      {key: 'collections_bookmark', caption: 'Collections Bookmark'},
      {key: 'crop_square', caption: 'Crop Square'},
      {key: 'panorama_fish_eye', caption: 'Panorama Fish Eye'},
      {key: 'lens', caption: 'Lens'},
      {key: 'looks_two', caption: 'Looks Two'},
      {key: 'looks_3', caption: 'Looks 3'},
      {key: 'filter_vintage', caption: 'Filter Vintage'},
      {key: 'compare', caption: 'Compare'},
      {key: 'filter_drama', caption: 'Filter Drama'},
      {key: 'image_search', caption: 'Image Search'},
      {key: 'healing', caption: 'Healing'},
      {key: 'rotate_left', caption: 'Rotate Left'},
      {key: 'auto_awesome_motion', caption: 'Auto Awesome Motion'},
      {key: 'center_focus_strong', caption: 'Center Focus Strong'},
      {key: 'crop', caption: 'Crop'},
      {key: 'blur_on', caption: 'Blur On'},
      {key: 'wb_incandescent', caption: 'Wb Incandescent'},
      {key: 'face_retouching_natural', caption: 'Face Retouching Natural'},
      {key: 'assistant', caption: 'Assistant'},
      {key: 'flare', caption: 'Flare'},
      {key: 'wb_cloudy', caption: 'Wb Cloudy'},
      {key: 'broken_image', caption: 'Broken Image'},
      {key: 'cases', caption: 'Cases'},
      {key: 'filter_none', caption: 'Filter None'},
      {key: 'colorize', caption: 'Colorize'},
      {key: 'filter_center_focus', caption: 'Filter Center Focus'},
      {key: 'auto_fix_normal', caption: 'Auto Fix Normal'},
      {key: 'crop_original', caption: 'Crop Original'},
      {key: 'brightness_4', caption: 'Brightness 4'},
      {key: 'dehaze', caption: 'Dehaze'},
      {key: 'nature_people', caption: 'Nature People'},
      {key: 'photo', caption: 'Photo'},
      {key: 'flash_off', caption: 'Flash Off'},
      {key: 'auto_awesome_mosaic', caption: 'Auto Awesome Mosaic'},
      {key: 'tag_faces', caption: 'Tag Faces'},
      {key: 'brightness_6', caption: 'Brightness 6'},
      {key: 'brightness_5', caption: 'Brightness 5'},
      {key: 'details', caption: 'Details'},
      {key: 'grain', caption: 'Grain'},
      {key: 'brightness_1', caption: 'Brightness 1'},
      {key: 'flip_camera_android', caption: 'Flip Camera Android'},
      {key: 'flip', caption: 'Flip'},
      {key: 'loupe', caption: 'Loupe'},
      {key: 'image_not_supported', caption: 'Image Not Supported'},
      {key: 'view_comfy', caption: 'View Comfy'},
      {key: 'flip_camera_ios', caption: 'Flip Camera iOS'},
      {key: 'filter_1', caption: 'Filter 1'},
      {key: 'movie_creation', caption: 'Movie Creation'},
      {key: 'bedtime', caption: 'Bedtime'},
      {key: 'add_to_photos', caption: 'Add To Photos'},
      {key: 'panorama', caption: 'Panorama'},
      {key: 'animation', caption: 'Animation'},
      {key: 'looks_4', caption: 'Looks 4'},
      {key: 'center_focus_weak', caption: 'Center Focus Weak'},
      {key: 'movie_filter', caption: 'Movie Filter'},
      {key: 'crop_din', caption: 'Crop Din'},
      {key: 'filter', caption: 'Filter'},
      {key: 'currency_bitcoin', caption: 'Currency Bitcoin'},
      {key: 'control_point_duplicate', caption: 'Control Point Duplicate'},
      {key: 'brightness_7', caption: 'Brightness 7'},
      {key: 'leak_add', caption: 'Leak Add'},
      {key: 'incomplete_circle', caption: 'Incomplete Circle'},
      {key: 'nature', caption: 'Nature'},
      {key: 'view_compact', caption: 'View Compact'},
      {key: 'texture', caption: 'Texture'},
      {key: 'timer_off', caption: 'Timer Off'},
      {key: 'currency_yen', caption: 'Currency Yen'},
      {key: 'photo_size_select_actual', caption: 'Photo Size Select Actual'},
      {key: 'video_camera_back', caption: 'Video Camera Back'},
      {key: 'transform', caption: 'Transform'},
      {key: 'motion_photos_on', caption: 'Motion Photos On'},
      {key: 'rotate_90_degrees_ccw', caption: 'Rotate 90 Degrees Ccw'},
      {key: 'looks_5', caption: 'Looks 5'},
      {key: 'photo_camera_front', caption: 'Photo Camera Front'},
      {key: 'mic_external_on', caption: 'Mic External On'},
      {key: 'contrast', caption: 'Contrast'},
      {key: 'gradient', caption: 'Gradient'},
      {key: 'wb_twilight', caption: 'Wb Twilight'},
      {key: 'currency_pound', caption: 'Currency Pound'},
      {key: 'assistant_photo', caption: 'Assistant Photo'},
      {key: 'hide_image', caption: 'Hide Image'},
      {key: 'exposure_plus_1', caption: 'Exposure Plus 1'},
      {key: 'music_off', caption: 'Music Off'},
      {key: 'crop_16_9', caption: 'Crop 16 9'},
      {key: 'thermostat_auto', caption: 'Thermostat Auto'},
      {key: 'exposure', caption: 'Exposure'},
      {key: 'shutter_speed', caption: 'Shutter Speed'},
      {key: 'filter_2', caption: 'Filter 2'},
      {key: 'photo_album', caption: 'Photo Album'},
      {key: 'filter_tilt_shift', caption: 'Filter Tilt Shift'},
      {key: 'hdr_strong', caption: 'Hdr Strong'},
      {key: 'looks', caption: 'Looks'},
      {key: 'linked_camera', caption: 'Linked Camera'},
      {key: 'brightness_3', caption: 'Brightness 3'},
      {key: 'vrpano', caption: 'Vrpano'},
      {key: 'looks_6', caption: 'Looks 6'},
      {key: 'blur_circular', caption: 'Blur Circular'},
      {key: 'flash_auto', caption: 'Flash Auto'},
      {key: 'crop_portrait', caption: 'Crop Portrait'},
      {key: 'motion_photos_auto', caption: 'Motion Photos Auto'},
      {key: 'photo_filter', caption: 'Photo Filter'},
      {key: 'iso', caption: 'Iso'},
      {key: 'brightness_2', caption: 'Brightness 2'},
      {key: 'photo_size_select_small', caption: 'Photo Size Select Small'},
      {key: 'tonality', caption: 'Tonality'},
      {key: 'filter_hdr', caption: 'Filter Hdr'},
      {key: 'crop_7_5', caption: 'Crop 7 5'},
      {key: 'rotate_90_degrees_cw', caption: 'Rotate 90 Degrees Cw'},
      {key: 'crop_rotate', caption: 'Crop Rotate'},
      {key: 'photo_size_select_large', caption: 'Photo Size Select Large'},
      {key: 'filter_3', caption: 'Filter 3'},
      {key: 'currency_ruble', caption: 'Currency Ruble'},
      {key: 'exposure_zero', caption: 'Exposure Zero'},
      {key: 'hdr_weak', caption: 'Hdr Weak'},
      {key: 'camera_front', caption: 'Camera Front'},
      {key: 'crop_5_4', caption: 'Crop 5 4'},
      {key: 'filter_frames', caption: 'Filter Frames'},
      {key: 'burst_mode', caption: 'Burst Mode'},
      {key: 'camera_roll', caption: 'Camera Roll'},
      {key: 'logo_dev', caption: 'Logo Dev'},
      {key: 'filter_b_and_w', caption: 'Filter B And W'},
      {key: 'blur_linear', caption: 'Blur Linear'},
      {key: 'crop_landscape', caption: 'Crop Landscape'},
      {key: 'crop_3_2', caption: 'Crop 3 2'},
      {key: 'switch_camera', caption: 'Switch Camera'},
      {key: 'switch_video', caption: 'Switch Video'},
      {key: 'filter_7', caption: 'Filter 7'},
      {key: 'filter_4', caption: 'Filter 4'},
      {key: 'exposure_plus_2', caption: 'Exposure Plus 2'},
      {key: 'filter_9_plus', caption: 'Filter 9 Plus'},
      {key: 'wb_iridescent', caption: 'Wb Iridescent'},
      {key: 'grid_off', caption: 'Grid Off'},
      {key: 'motion_photos_paused', caption: 'Motion Photos Paused'},
      {key: 'photo_camera_back', caption: 'Photo Camera Back'},
      {key: 'monochrome_photos', caption: 'Monochrome Photos'},
      {key: 'filter_5', caption: 'Filter 5'},
      {key: 'auto_fix_off', caption: 'Auto Fix Off'},
      {key: 'exposure_neg_1', caption: 'Exposure Neg 1'},
      {key: 'face_retouching_off', caption: 'Face Retouching Off'},
      {key: 'panorama_photosphere', caption: 'Panorama Photosphere'},
      {key: 'leak_remove', caption: 'Leak Remove'},
      {key: 'filter_8', caption: 'Filter 8'},
      {key: 'filter_9', caption: 'Filter 9'},
      {key: 'video_stable', caption: 'Video Stable'},
      {key: 'timer_10', caption: 'Timer 10'},
      {key: 'filter_6', caption: 'Filter 6'},
      {key: 'wb_shade', caption: 'Wb Shade'},
      {key: 'blur_off', caption: 'Blur Off'},
      {key: 'raw_on', caption: 'Raw On'},
      {key: 'motion_photos_off', caption: 'Motion Photos Off'},
      {key: 'motion_photos_pause', caption: 'Motion Photos Pause'},
      {key: 'hdr_on', caption: 'Hdr On'},
      {key: 'vignette', caption: 'Vignette'},
      {key: 'deblur', caption: 'Deblur'},
      {key: 'panorama_horizontal', caption: 'Panorama Horizontal'},
      {key: 'image_aspect_ratio', caption: 'Image Aspect Ratio'},
      {key: '30fps_select', caption: '30fps Select'},
      {key: 'dirty_lens', caption: 'Dirty Lens'},
      {key: 'camera_rear', caption: 'Camera Rear'},
      {key: 'timer_3', caption: 'Timer 3'},
      {key: '60fps_select', caption: '60fps Select'},
      {key: 'panorama_wide_angle_select', caption: 'Panorama Wide Angle Select'},
      {key: 'currency_yuan', caption: 'Currency Yuan'},
      {key: 'currency_lira', caption: 'Currency Lira'},
      {key: '24mp', caption: '24mp'},
      {key: 'exposure_neg_2', caption: 'Exposure Neg 2'},
      {key: 'autofps_select', caption: 'Autofps Select'},
      {key: 'panorama_horizontal_select', caption: 'Panorama Horizontal Select'},
      {key: 'panorama_photosphere_select', caption: 'Panorama Photosphere Select'},
      {key: 'wb_auto', caption: 'Wb Auto'},
      {key: 'hdr_plus', caption: 'Hdr Plus'},
      {key: 'panorama_wide_angle', caption: 'Panorama Wide Angle'},
      {key: 'panorama_vertical_select', caption: 'Panorama Vertical Select'},
      {key: 'mic_external_off', caption: 'Mic External Off'},
      {key: '12mp', caption: '12mp'},
      {key: 'panorama_vertical', caption: 'Panorama Vertical'},
      {key: 'currency_franc', caption: 'Currency Franc'},
      {key: 'mp', caption: 'Mp'},
      {key: 'hdr_enhanced_select', caption: 'Hdr Enhanced Select'},
      {key: 'hevc', caption: 'Hevc'},
      {key: '18mp', caption: '18mp'},
      {key: '10mp', caption: '10mp'},
      {key: 'bedtime_off', caption: 'Bedtime Off'},
      {key: 'raw_off', caption: 'Raw Off'},
      {key: '23mp', caption: '23mp'},
      {key: 'hdr_off', caption: 'Hdr Off'},
      {key: '11mp', caption: '11mp'},
      {key: '20mp', caption: '20mp'},
      {key: '3mp', caption: '3mp'},
      {key: '5mp', caption: '5mp'},
      {key: '13mp', caption: '13mp'},
      {key: '16mp', caption: '16mp'},
      {key: '21mp', caption: '21mp'},
      {key: '15mp', caption: '15mp'},
      {key: '2mp', caption: '2mp'},
      {key: '17mp', caption: '17mp'},
      {key: '14mp', caption: '14mp'},
      {key: '22mp', caption: '22mp'},
      {key: '19mp', caption: '19mp'},
      {key: '4mp', caption: '4mp'},
      {key: '9mp', caption: '9mp'},
      {key: '6mp', caption: '6mp'},
      {key: '7mp', caption: '7mp'},
      {
        key: '8mp',
        caption: '8mp',
      },
    ],
  },
  {
    group: 'Communication',
    icons: [
      {key: 'email', caption: 'Email'},
      {key: 'location_on', caption: 'Location On'},
      {key: 'call', caption: 'Call'},
      {key: 'phone', caption: 'Phone'},
      {key: 'business', caption: 'Business'},
      {key: 'chat', caption: 'Chat'},
      {key: 'mail_outline', caption: 'Mail Outline'},
      {key: 'list_alt', caption: 'List Alt'},
      {key: 'qr_code_scanner', caption: 'Qr Code Scanner'},
      {key: 'vpn_key', caption: 'Vpn Key'},
      {key: 'chat_bubble_outline', caption: 'Chat Bubble Outline'},
      {key: 'alternate_email', caption: 'Alternate Email'},
      {key: 'forum', caption: 'Forum'},
      {key: 'chat_bubble', caption: 'Chat Bubble'},
      {key: 'textsms', caption: 'Textsms'},
      {key: 'contact_mail', caption: 'Contact Mail'},
      {key: 'person_search', caption: 'Person Search'},
      {key: 'sentiment_satisfied_alt', caption: 'Sentiment Satisfied Alt'},
      {key: 'qr_code', caption: 'Qr Code'},
      {key: 'qr_code_2', caption: 'Qr Code 2'},
      {key: 'message', caption: 'Message'},
      {key: 'contacts', caption: 'Contacts'},
      {key: 'comment', caption: 'Comment'},
      {key: 'key', caption: 'Key'},
      {key: 'import_contacts', caption: 'Import Contacts'},
      {key: 'app_registration', caption: 'App Registration'},
      {key: 'contact_phone', caption: 'Contact Phone'},
      {key: 'import_export', caption: 'Import Export'},
      {key: 'live_help', caption: 'Live Help'},
      {key: 'forward_to_inbox', caption: 'Forward To Inbox'},
      {key: 'hourglass_bottom', caption: 'Hourglass Bottom'},
      {key: 'hourglass_top', caption: 'Hourglass Top'},
      {key: 'rss_feed', caption: 'Rss Feed'},
      {key: 'mark_email_read', caption: 'Mark Email Read'},
      {key: 'hub', caption: 'Hub'},
      {key: 'read_more', caption: 'Read More'},
      {key: 'document_scanner', caption: 'Document Scanner'},
      {key: 'more_time', caption: 'More Time'},
      {key: 'mark_email_unread', caption: 'Mark Email Unread'},
      {key: 'call_end', caption: 'Call End'},
      {key: 'clear_all', caption: 'Clear All'},
      {key: 'dialpad', caption: 'Dialpad'},
      {key: 'phone_enabled', caption: 'Phone Enabled'},
      {key: 'mark_chat_unread', caption: 'Mark Chat Unread'},
      {key: 'cancel_presentation', caption: 'Cancel Presentation'},
      {key: '3p', caption: '3p'},
      {key: 'call_made', caption: 'Call Made'},
      {key: 'screen_share', caption: 'Screen Share'},
      {key: 'call_split', caption: 'Call Split'},
      {key: 'unsubscribe', caption: 'Unsubscribe'},
      {key: 'domain_verification', caption: 'Domain Verification'},
      {key: 'present_to_all', caption: 'Present To All'},
      {key: 'mark_chat_read', caption: 'Mark Chat Read'},
      {key: 'co_present', caption: 'Co Present'},
      {key: 'add_ic_call', caption: 'Add Ic Call'},
      {key: 'phonelink_ring', caption: 'Phonelink Ring'},
      {key: 'stay_current_portrait', caption: 'Stay Current Portrait'},
      {key: 'call_received', caption: 'Call Received'},
      {key: 'phonelink_lock', caption: 'Phonelink Lock'},
      {key: 'phone_disabled', caption: 'Phone Disabled'},
      {key: 'ring_volume', caption: 'Ring Volume'},
      {key: 'cell_tower', caption: 'Cell Tower'},
      {key: 'location_off', caption: 'Location Off'},
      {key: 'phonelink_setup', caption: 'Phonelink Setup'},
      {key: 'duo', caption: 'Duo'},
      {key: 'stay_primary_portrait', caption: 'Stay Primary Portrait'},
      {key: 'swap_calls', caption: 'Swap Calls'},
      {key: 'voicemail', caption: 'Voicemail'},
      {key: 'call_merge', caption: 'Call Merge'},
      {key: 'phonelink_erase', caption: 'Phonelink Erase'},
      {key: 'mobile_screen_share', caption: 'Mobile Screen Share'},
      {key: 'person_add_disabled', caption: 'Person Add Disabled'},
      {key: 'domain_disabled', caption: 'Domain Disabled'},
      {key: 'call_missed_outgoing', caption: 'Call Missed Outgoing'},
      {key: 'spoke', caption: 'Spoke'},
      {key: 'speaker_phone', caption: 'Speaker Phone'},
      {key: 'desktop_access_disabled', caption: 'Desktop Access Disabled'},
      {key: 'cell_wifi', caption: 'Cell Wifi'},
      {key: 'stop_screen_share', caption: 'Stop Screen Share'},
      {key: 'print_disabled', caption: 'Print Disabled'},
      {key: 'mark_unread_chat_alt', caption: 'Mark Unread Chat Alt'},
      {key: 'call_missed', caption: 'Call Missed'},
      {key: 'contact_emergency', caption: 'Contact Emergency'},
      {key: 'pause_presentation', caption: 'Pause Presentation'},
      {key: 'dialer_sip', caption: 'Dialer Sip'},
      {key: 'comments_disabled', caption: 'Comments Disabled'},
      {key: 'invert_colors_off', caption: 'Invert Colors Off'},
      {key: 'wifi_calling', caption: 'Wifi Calling'},
      {key: 'rtt', caption: 'RTT'},
      {key: 'portable_wifi_off', caption: 'Portable Wifi Off'},
      {key: 'send_time_extension', caption: 'Send Time Extension'},
      {key: 'mail_lock', caption: 'Mail Lock'},
      {key: 'stay_current_landscape', caption: 'Stay Current Landscape'},
      {key: 'sip', caption: 'Sip'},
      {key: 'nat', caption: 'Nat'},
      {key: 'stay_primary_landscape', caption: 'Stay Primary Landscape'},
      {key: 'key_off', caption: 'Key Off'},
      {key: 'no_sim', caption: 'No Sim'},
      {
        key: 'vpn_key_off',
        caption: 'Vpn Key Off',
      },
    ],
  },
  {
    group: 'Maps',
    icons: [
      {key: 'local_shipping', caption: 'Local Shipping'},
      {key: 'place', caption: 'Place'},
      {key: 'menu_book', caption: 'Menu Book'},
      {key: 'local_offer', caption: 'Local Offer'},
      {key: 'badge', caption: 'Badge'},
      {key: 'map', caption: 'Map'},
      {key: 'category', caption: 'Category'},
      {key: 'restaurant', caption: 'Restaurant'},
      {key: 'directions_car', caption: 'Directions Car'},
      {key: 'local_fire_department', caption: 'Local Fire Department'},
      {key: 'volunteer_activism', caption: 'Volunteer Activism'},
      {key: 'my_location', caption: 'My Location'},
      {key: 'flight', caption: 'Flight'},
      {key: 'local_mall', caption: 'Local Mall'},
      {key: 'near_me', caption: 'Near Me'},
      {key: 'handyman', caption: 'Handyman'},
      {key: 'directions_run', caption: 'Directions Run'},
      {key: 'restaurant_menu', caption: 'Restaurant Menu'},
      {key: 'layers', caption: 'Layers'},
      {key: 'medical_services', caption: 'Medical Services'},
      {key: 'directions_walk', caption: 'Directions Walk'},
      {key: 'lunch_dining', caption: 'Lunch Dining'},
      {key: 'local_hospital', caption: 'Local Hospital'},
      {key: 'celebration', caption: 'Celebration'},
      {key: 'local_library', caption: 'Local Library'},
      {key: 'pin_drop', caption: 'Pin Drop'},
      {key: 'park', caption: 'Park'},
      {key: 'local_atm', caption: 'Local Atm'},
      {key: 'local_activity', caption: 'Local Activity'},
      {key: 'person_pin', caption: 'Person Pin'},
      {key: 'design_services', caption: 'Design Services'},
      {key: 'local_cafe', caption: 'Local Cafe'},
      {key: 'rate_review', caption: 'Rate Review'},
      {key: 'delivery_dining', caption: 'Delivery Dining'},
      {key: 'directions_bus', caption: 'Directions Bus'},
      {key: 'local_police', caption: 'Local Police'},
      {key: 'directions_bike', caption: 'Directions Bike'},
      {key: 'fastfood', caption: 'Fastfood'},
      {key: 'directions_car_filled', caption: 'Directions Car Filled'},
      {key: 'home_repair_service', caption: 'Home Repair Service'},
      {key: 'zoom_out_map', caption: 'Zoom Out Map'},
      {key: 'cleaning_services', caption: 'Cleaning Services'},
      {key: 'hotel', caption: 'Hotel'},
      {key: 'local_phone', caption: 'Local Phone'},
      {key: 'miscellaneous_services', caption: 'Miscellaneous Services'},
      {key: 'local_grocery_store', caption: 'Local Grocery Store'},
      {key: 'navigation', caption: 'Navigation'},
      {key: 'local_gas_station', caption: 'Local Gas Station'},
      {key: 'train', caption: 'Train'},
      {key: 'diamond', caption: 'Diamond'},
      {key: 'person_pin_circle', caption: 'Person Pin Circle'},
      {key: 'local_parking', caption: 'Local Parking'},
      {key: 'local_florist', caption: 'Local Florist'},
      {key: 'local_post_office', caption: 'Local Post Office'},
      {key: 'money', caption: 'Money'},
      {key: 'directions', caption: 'Directions'},
      {key: 'two_wheeler', caption: 'Two Wheeler'},
      {key: 'factory', caption: 'Factory'},
      {key: 'add_business', caption: 'Add Business'},
      {key: 'electrical_services', caption: 'Electrical Services'},
      {key: 'traffic', caption: 'Traffic'},
      {key: 'route', caption: 'Route'},
      {key: 'directions_boat', caption: 'Directions Boat'},
      {key: 'local_bar', caption: 'Local Bar'},
      {key: 'alt_route', caption: 'Alt Route'},
      {key: 'beenhere', caption: 'Beenhere'},
      {key: 'agriculture', caption: 'Agriculture'},
      {key: 'warehouse', caption: 'Warehouse'},
      {key: 'pedal_bike', caption: 'Pedal Bike'},
      {key: '360', caption: '360'},
      {key: 'emergency', caption: 'Emergency'},
      {key: 'liquor', caption: 'Liquor'},
      {key: 'moving', caption: 'Moving'},
      {key: 'local_airport', caption: 'Local Airport'},
      {key: 'sailing', caption: 'Sailing'},
      {key: 'add_location_alt', caption: 'Add Location Alt'},
      {key: 'local_dining', caption: 'Local Dining'},
      {key: 'maps_ugc', caption: 'Maps Ugc'},
      {key: 'local_taxi', caption: 'Local Taxi'},
      {key: 'ramen_dining', caption: 'Ramen Dining'},
      {key: 'trip_origin', caption: 'Trip Origin'},
      {key: 'local_laundry_service', caption: 'Local Laundry Service'},
      {key: 'hail', caption: 'Hail'},
      {key: 'local_drink', caption: 'Local Drink'},
      {key: 'directions_bus_filled', caption: 'Directions Bus Filled'},
      {key: 'local_printshop', caption: 'Local Printshop'},
      {key: 'theater_comedy', caption: 'Theater Comedy'},
      {key: 'local_pizza', caption: 'Local Pizza'},
      {key: 'not_listed_location', caption: 'Not Listed Location'},
      {key: 'forest', caption: 'Forest'},
      {key: 'transfer_within_a_station', caption: 'Transfer Within A Station'},
      {key: 'add_location', caption: 'Add Location'},
      {key: 'dinner_dining', caption: 'Dinner Dining'},
      {key: 'bakery_dining', caption: 'Bakery Dining'},
      {key: 'wine_bar', caption: 'Wine Bar'},
      {key: 'terrain', caption: 'Terrain'},
      {key: 'multiple_stop', caption: 'Multiple Stop'},
      {key: 'takeout_dining', caption: 'Takeout Dining'},
      {key: 'store_mall_directory', caption: 'Store Mall Directory'},
      {key: 'icecream', caption: 'Icecream'},
      {key: 'museum', caption: 'Museum'},
      {key: 'nightlife', caption: 'Nightlife'},
      {key: 'local_pharmacy', caption: 'Local Pharmacy'},
      {key: 'hardware', caption: 'Hardware'},
      {key: 'departure_board', caption: 'Departure Board'},
      {key: 'add_road', caption: 'Add Road'},
      {key: 'set_meal', caption: 'Set Meal'},
      {key: 'ev_station', caption: 'Ev Station'},
      {key: 'electric_car', caption: 'Electric Car'},
      {key: 'local_see', caption: 'Local See'},
      {key: 'festival', caption: 'Festival'},
      {key: 'plumbing', caption: 'Plumbing'},
      {key: 'car_rental', caption: 'Car Rental'},
      {key: 'layers_clear', caption: 'Layers Clear'},
      {key: 'attractions', caption: 'Attractions'},
      {key: 'edit_location', caption: 'Edit Location'},
      {key: 'medical_information', caption: 'Medical Information'},
      {key: 'zoom_in_map', caption: 'Zoom In Map'},
      {key: 'local_convenience_store', caption: 'Local Convenience Store'},
      {key: 'pest_control', caption: 'Pest Control'},
      {key: 'run_circle', caption: 'Run Circle'},
      {key: 'dry_cleaning', caption: 'Dry Cleaning'},
      {key: 'edit_road', caption: 'Edit Road'},
      {key: 'church', caption: 'Church'},
      {key: 'edit_attributes', caption: 'Edit Attributes'},
      {key: 'edit_location_alt', caption: 'Edit Location Alt'},
      {key: 'moped', caption: 'Moped'},
      {key: 'wrong_location', caption: 'Wrong Location'},
      {key: 'car_repair', caption: 'Car Repair'},
      {key: 'local_movies', caption: 'Local Movies'},
      {key: 'satellite', caption: 'Satellite'},
      {key: 'directions_boat_filled', caption: 'Directions Boat Filled'},
      {key: 'soup_kitchen', caption: 'Soup Kitchen'},
      {key: 'signpost', caption: 'Signpost'},
      {key: 'tram', caption: 'Tram'},
      {key: 'taxi_alert', caption: 'Taxi Alert'},
      {key: 'breakfast_dining', caption: 'Breakfast Dining'},
      {key: 'atm', caption: 'Atm'},
      {key: 'merge', caption: 'Merge'},
      {key: 'straight', caption: 'Straight'},
      {key: 'subway', caption: 'Subway'},
      {key: 'transit_enterexit', caption: 'Transit Enterexit'},
      {key: 'brunch_dining', caption: 'Brunch Dining'},
      {key: 'crisis_alert', caption: 'Crisis Alert'},
      {key: 'hvac', caption: 'Hvac'},
      {key: 'electric_bike', caption: 'Electric Bike'},
      {key: 'directions_transit', caption: 'Directions Transit'},
      {key: 'connecting_airports', caption: 'Connecting Airports'},
      {key: 'electric_scooter', caption: 'Electric Scooter'},
      {key: 'egg', caption: 'Egg'},
      {key: 'bus_alert', caption: 'Bus Alert'},
      {key: 'local_car_wash', caption: 'Local Car Wash'},
      {key: 'local_hotel', caption: 'Local Hotel'},
      {key: 'mode_of_travel', caption: 'Mode Of Travel'},
      {key: 'stadium', caption: 'Stadium'},
      {key: 'safety_check', caption: 'Safety Check'},
      {key: 'castle', caption: 'Castle'},
      {key: 'streetview', caption: 'Streetview'},
      {key: 'car_crash', caption: 'Car Crash'},
      {key: 'mosque', caption: 'Mosque'},
      {key: 'directions_subway', caption: 'Directions Subway'},
      {key: 'compass_calibration', caption: 'Compass Calibration'},
      {key: 'electric_rickshaw', caption: 'Electric Rickshaw'},
      {key: 'turn_right', caption: 'Turn Right'},
      {key: 'airline_stops', caption: 'Airline Stops'},
      {key: 'directions_railway', caption: 'Directions Railway'},
      {key: 'no_meals', caption: 'No Meals'},
      {key: 'fork_right', caption: 'Fork Right'},
      {key: 'railway_alert', caption: 'Railway Alert'},
      {key: 'electric_moped', caption: 'Electric Moped'},
      {key: 'local_play', caption: 'Local Play'},
      {key: 'no_crash', caption: 'No Crash'},
      {key: 'turn_left', caption: 'Turn Left'},
      {key: 'airlines', caption: 'Airlines'},
      {key: 'bike_scooter', caption: 'Bike Scooter'},
      {key: 'u_turn_left', caption: 'U Turn Left'},
      {key: 'pest_control_rodent', caption: 'Pest Control Rodent'},
      {key: 'egg_alt', caption: 'Egg Alt'},
      {key: 'near_me_disabled', caption: 'Near Me Disabled'},
      {key: 'snowmobile', caption: 'Snowmobile'},
      {key: 'directions_transit_filled', caption: 'Directions Transit Filled'},
      {key: 'tire_repair', caption: 'Tire Repair'},
      {key: 'no_transfer', caption: 'No Transfer'},
      {key: 'directions_subway_filled', caption: 'Directions Subway Filled'},
      {key: 'minor_crash', caption: 'Minor Crash'},
      {key: 'flight_class', caption: 'Flight Class'},
      {key: 'kebab_dining', caption: 'Kebab Dining'},
      {key: 'directions_railway_filled', caption: 'Directions Railway Filled'},
      {key: 'sos', caption: 'Sos'},
      {key: 'temple_buddhist', caption: 'Temple Buddhist'},
      {key: 'fort', caption: 'Fort'},
      {key: 'emergency_share', caption: 'Emergency Share'},
      {key: 'u_turn_right', caption: 'U Turn Right'},
      {key: 'fire_truck', caption: 'Fire Truck'},
      {key: 'temple_hindu', caption: 'Temple Hindu'},
      {key: 'synagogue', caption: 'Synagogue'},
      {key: 'fork_left', caption: 'Fork Left'},
      {key: 'remove_road', caption: 'Remove Road'},
      {key: 'turn_sharp_right', caption: 'Turn Sharp Right'},
      {key: 'screen_rotation_alt', caption: 'Screen Rotation Alt'},
      {key: 'roundabout_right', caption: 'Roundabout Right'},
      {key: 'turn_slight_right', caption: 'Turn Slight Right'},
      {key: 'turn_slight_left', caption: 'Turn Slight Left'},
      {key: 'roundabout_left', caption: 'Roundabout Left'},
      {key: 'emergency_recording', caption: 'Emergency Recording'},
      {key: 'turn_sharp_left', caption: 'Turn Sharp Left'},
      {key: 'ramp_left', caption: 'Ramp Left'},
      {key: 'ramp_right', caption: 'Ramp Right'},
      {
        key: 'fire_hydrant_alt',
        caption: 'Fire Hydrant Alt',
      },
    ],
  },
  {
    group: 'File',
    icons: [
      {key: 'file_download', caption: 'File Download'},
      {key: 'file_upload', caption: 'File Upload'},
      {key: 'download', caption: 'Download'},
      {key: 'folder', caption: 'Folder'},
      {key: 'grid_view', caption: 'Grid View'},
      {key: 'upload_file', caption: 'Upload File'},
      {key: 'cloud_upload', caption: 'Cloud Upload'},
      {key: 'folder_open', caption: 'Folder Open'},
      {key: 'text_snippet', caption: 'Text Snippet'},
      {key: 'cloud', caption: 'Cloud'},
      {key: 'request_quote', caption: 'Request Quote'},
      {key: 'cloud_download', caption: 'Cloud Download'},
      {key: 'drive_file_rename_outline', caption: 'Drive File Rename Outline'},
      {key: 'upload', caption: 'Upload'},
      {key: 'attachment', caption: 'Attachment'},
      {key: 'download_for_offline', caption: 'Download For Offline'},
      {key: 'newspaper', caption: 'Newspaper'},
      {key: 'create_new_folder', caption: 'Create New Folder'},
      {key: 'downloading', caption: 'Downloading'},
      {key: 'folder_shared', caption: 'Folder Shared'},
      {key: 'cloud_done', caption: 'Cloud Done'},
      {key: 'cloud_queue', caption: 'Cloud Queue'},
      {key: 'workspaces', caption: 'Workspaces'},
      {key: 'topic', caption: 'Topic'},
      {key: 'approval', caption: 'Approval'},
      {key: 'download_done', caption: 'Download Done'},
      {key: 'cloud_off', caption: 'Cloud Off'},
      {key: 'drive_file_move', caption: 'Drive File Move'},
      {key: 'file_open', caption: 'File Open'},
      {key: 'drive_folder_upload', caption: 'Drive Folder Upload'},
      {key: 'file_download_done', caption: 'File Download Done'},
      {key: 'cloud_sync', caption: 'Cloud Sync'},
      {key: 'attach_email', caption: 'Attach Email'},
      {key: 'rule_folder', caption: 'Rule Folder'},
      {key: 'folder_zip', caption: 'Folder Zip'},
      {key: 'folder_copy', caption: 'Folder Copy'},
      {key: 'cloud_circle', caption: 'Cloud Circle'},
      {key: 'snippet_folder', caption: 'Snippet Folder'},
      {key: 'difference', caption: 'Difference'},
      {key: 'file_download_off', caption: 'File Download Off'},
      {key: 'folder_delete', caption: 'Folder Delete'},
      {key: 'drive_file_move_rtl', caption: 'Drive File Move Rtl'},
      {key: 'folder_off', caption: 'Folder Off'},
      {
        key: 'format_overline',
        caption: 'Format Overline',
      },
    ],
  },
  {
    group: 'Audio & Video',
    icons: [
      {key: 'play_arrow', caption: 'Play Arrow'},
      {key: 'play_circle_filled', caption: 'Play Circle Filled'},
      {key: 'videocam', caption: 'Videocam'},
      {key: 'play_circle', caption: 'Play Circle'},
      {key: 'mic', caption: 'Mic'},
      {key: 'volume_up', caption: 'Volume Up'},
      {key: 'pause', caption: 'Pause'},
      {key: 'play_circle_outline', caption: 'Play Circle Outline'},
      {key: 'replay', caption: 'Replay'},
      {key: 'volume_off', caption: 'Volume Off'},
      {key: 'skip_next', caption: 'Skip Next'},
      {key: 'library_books', caption: 'Library Books'},
      {key: 'fiber_manual_record', caption: 'Fiber Manual Record'},
      {key: 'speed', caption: 'Speed'},
      {key: 'stop', caption: 'Stop'},
      {key: 'movie', caption: 'Movie'},
      {key: 'skip_previous', caption: 'Skip Previous'},
      {key: 'new_releases', caption: 'New Releases'},
      {key: 'playlist_add', caption: 'Playlist Add'},
      {key: 'loop', caption: 'Loop'},
      {key: 'equalizer', caption: 'Equalizer'},
      {key: 'fast_forward', caption: 'Fast Forward'},
      {key: 'web', caption: 'Web'},
      {key: 'video_library', caption: 'Video Library'},
      {key: 'playlist_add_check', caption: 'Playlist Add Check'},
      {key: 'library_add', caption: 'Library Add'},
      {key: 'mic_off', caption: 'Mic Off'},
      {key: 'pause_circle', caption: 'Pause Circle'},
      {key: 'stop_circle', caption: 'Stop Circle'},
      {key: 'subscriptions', caption: 'Subscriptions'},
      {key: 'volume_mute', caption: 'Volume Mute'},
      {key: 'video_call', caption: 'Video Call'},
      {key: 'repeat', caption: 'Repeat'},
      {key: 'not_interested', caption: 'Not Interested'},
      {key: 'shuffle', caption: 'Shuffle'},
      {key: 'sort_by_alpha', caption: 'Sort By Alpha'},
      {key: 'fast_rewind', caption: 'Fast Rewind'},
      {key: 'mic_none', caption: 'Mic None'},
      {key: 'library_music', caption: 'Library Music'},
      {key: 'volume_down', caption: 'Volume Down'},
      {key: 'videocam_off', caption: 'Videocam Off'},
      {key: 'recent_actors', caption: 'Recent Actors'},
      {key: 'web_asset', caption: 'Web Asset'},
      {key: 'library_add_check', caption: 'Library Add Check'},
      {key: 'hearing', caption: 'Hearing'},
      {key: 'queue_music', caption: 'Queue Music'},
      {key: 'pause_circle_filled', caption: 'Pause Circle Filled'},
      {key: 'subtitles', caption: 'Subtitles'},
      {key: 'fiber_new', caption: 'Fiber New'},
      {key: 'pause_circle_outline', caption: 'Pause Circle Outline'},
      {key: 'note', caption: 'Note'},
      {key: 'av_timer', caption: 'Av Timer'},
      {key: 'album', caption: 'Album'},
      {key: 'playlist_play', caption: 'Playlist Play'},
      {key: 'queue', caption: 'Queue'},
      {key: 'games', caption: 'Games'},
      {key: 'radio', caption: 'Radio'},
      {key: 'replay_circle_filled', caption: 'Replay Circle Filled'},
      {key: 'branding_watermark', caption: 'Branding Watermark'},
      {key: 'forward_10', caption: 'Forward 10'},
      {key: 'replay_10', caption: 'Replay 10'},
      {key: 'closed_caption', caption: 'Closed Caption'},
      {key: 'video_settings', caption: 'Video Settings'},
      {key: 'featured_play_list', caption: 'Featured Play List'},
      {key: 'high_quality', caption: 'High Quality'},
      {key: 'playlist_add_check_circle', caption: 'Playlist Add Check Circle'},
      {key: 'control_camera', caption: 'Control Camera'},
      {key: 'playlist_remove', caption: 'Playlist Remove'},
      {key: 'add_to_queue', caption: 'Add To Queue'},
      {key: 'slow_motion_video', caption: 'Slow Motion Video'},
      {key: 'repeat_one', caption: 'Repeat One'},
      {key: 'airplay', caption: 'Airplay'},
      {key: 'call_to_action', caption: 'Call To Action'},
      {key: 'snooze', caption: 'Snooze'},
      {key: 'hd', caption: 'Hd'},
      {key: 'repeat_on', caption: 'Repeat On'},
      {key: 'replay_30', caption: 'Replay 30'},
      {key: 'closed_caption_off', caption: 'Closed Caption Off'},
      {key: 'featured_video', caption: 'Featured Video'},
      {key: 'shuffle_on', caption: 'Shuffle On'},
      {key: 'forward_30', caption: 'Forward 30'},
      {key: 'audio_file', caption: 'Audio File'},
      {key: '5g', caption: '5g'},
      {key: 'playlist_add_circle', caption: 'Playlist Add Circle'},
      {key: 'music_video', caption: 'Music Video'},
      {key: 'queue_play_next', caption: 'Queue Play Next'},
      {key: 'replay_5', caption: 'Replay 5'},
      {key: 'interpreter_mode', caption: 'Interpreter Mode'},
      {key: 'video_file', caption: 'Video File'},
      {key: 'art_track', caption: 'Art Track'},
      {key: 'hearing_disabled', caption: 'Hearing Disabled'},
      {key: 'forward_5', caption: 'Forward 5'},
      {key: 'explicit', caption: 'Explicit'},
      {key: 'video_label', caption: 'Video Label'},
      {key: '4k', caption: '4k'},
      {key: 'fiber_smart_record', caption: 'Fiber Smart Record'},
      {key: 'repeat_one_on', caption: 'Repeat One On'},
      {key: 'closed_caption_disabled', caption: 'Closed Caption Disabled'},
      {key: 'remove_from_queue', caption: 'Remove From Queue'},
      {key: 'surround_sound', caption: 'Surround Sound'},
      {key: 'play_disabled', caption: 'Play Disabled'},
      {key: 'web_asset_off', caption: 'Web Asset Off'},
      {key: 'sd', caption: 'Sd'},
      {key: 'lyrics', caption: 'Lyrics'},
      {key: 'missed_video_call', caption: 'Missed Video Call'},
      {key: '10k', caption: '10k'},
      {key: 'fiber_pin', caption: 'Fiber Pin'},
      {key: 'fiber_dvr', caption: 'Fiber Dvr'},
      {key: '4k_plus', caption: '4k Plus'},
      {key: '1k', caption: '1k'},
      {key: '2k', caption: '2k'},
      {key: '1k_plus', caption: '1k Plus'},
      {key: '8k', caption: '8k'},
      {key: '9k_plus', caption: '9k Plus'},
      {key: '5k', caption: '5k'},
      {key: '8k_plus', caption: '8k Plus'},
      {key: '3k', caption: '3k'},
      {key: '5k_plus', caption: '5k Plus'},
      {key: '9k', caption: '9k'},
      {key: '7k', caption: '7k'},
      {key: '6k_plus', caption: '6k Plus'},
      {key: '7k_plus', caption: '7k Plus'},
      {key: '2k_plus', caption: '2k Plus'},
      {key: '6k', caption: '6k'},
      {
        key: '3k_plus',
        caption: '3k Plus',
      },
    ],
  },
  {
    group: 'Toggle',
    icons: [
      {key: 'star', caption: 'Star'},
      {key: 'check_box', caption: 'Check Box'},
      {key: 'check_box_outline_blank', caption: 'Check Box Outline Blank'},
      {key: 'radio_button_unchecked', caption: 'Radio Button Unchecked'},
      {key: 'radio_button_checked', caption: 'Radio Button Checked'},
      {key: 'star_border', caption: 'Star Border'},
      {key: 'toggle_on', caption: 'Toggle On'},
      {key: 'star_outline', caption: 'Star Outline'},
      {key: 'toggle_off', caption: 'Toggle Off'},
      {key: 'star_half', caption: 'Star Half'},
      {key: 'indeterminate_check_box', caption: 'Indeterminate Check Box'},
      {key: 'star_purple500', caption: 'Star Purple500'},
      {
        key: 'star_border_purple500',
        caption: 'Star Border Purple500',
      },
    ],
  },
  {
    group: 'Alert',
    icons: [
      {key: 'warning', caption: 'Warning'},
      {key: 'error', caption: 'Error'},
      {key: 'error_outline', caption: 'Error Outline'},
      {key: 'warning_amber', caption: 'Warning Amber'},
      {key: 'notification_important', caption: 'Notification Important'},
      {key: 'add_alert', caption: 'Add Alert'},
      {
        key: 'auto_delete',
        caption: 'Auto Delete',
      },
    ],
  },
  {
    group: 'Notification',
    icons: [
      {key: 'support_agent', caption: 'Support Agent'},
      {key: 'wifi', caption: 'Wifi'},
      {key: 'account_tree', caption: 'Account Tree'},
      {key: 'sync', caption: 'Sync'},
      {key: 'priority_high', caption: 'Priority High'},
      {key: 'event_available', caption: 'Event Available'},
      {key: 'event_note', caption: 'Event Note'},
      {key: 'confirmation_number', caption: 'Confirmation Number'},
      {key: 'sms', caption: 'Sms'},
      {key: 'live_tv', caption: 'Live Tv'},
      {key: 'ondemand_video', caption: 'Ondemand Video'},
      {key: 'drive_eta', caption: 'Drive Eta'},
      {key: 'wifi_off', caption: 'Wifi Off'},
      {key: 'event_busy', caption: 'Event Busy'},
      {key: 'do_not_disturb_on', caption: 'Do Not Disturb On'},
      {key: 'wc', caption: 'Wc'},
      {key: 'more', caption: 'More'},
      {key: 'power', caption: 'Power'},
      {key: 'do_not_disturb', caption: 'Do Not Disturb'},
      {key: 'sync_problem', caption: 'Sync Problem'},
      {key: 'time_to_leave', caption: 'Time To Leave'},
      {key: 'do_disturb_on', caption: 'Do Disturb On'},
      {key: 'vpn_lock', caption: 'Vpn Lock'},
      {key: 'running_with_errors', caption: 'Running With Errors'},
      {key: 'folder_special', caption: 'Folder Special'},
      {key: 'enhanced_encryption', caption: 'Enhanced Encryption'},
      {key: 'do_disturb', caption: 'Do Disturb'},
      {key: 'sms_failed', caption: 'Sms Failed'},
      {key: 'network_check', caption: 'Network Check'},
      {key: 'phone_callback', caption: 'Phone Callback'},
      {key: 'adb', caption: 'ADB'},
      {key: 'phone_forwarded', caption: 'Phone Forwarded'},
      {key: 'system_update', caption: 'System Update'},
      {key: 'power_off', caption: 'Power Off'},
      {key: 'personal_video', caption: 'Personal Video'},
      {key: 'voice_chat', caption: 'Voice Chat'},
      {key: 'vibration', caption: 'Vibration'},
      {key: 'airline_seat_recline_normal', caption: 'Airline Seat Recline Normal'},
      {key: 'do_disturb_alt', caption: 'Do Disturb Alt'},
      {key: 'do_not_disturb_alt', caption: 'Do Not Disturb Alt'},
      {key: 'sync_disabled', caption: 'Sync Disabled'},
      {key: 'tap_and_play', caption: 'Tap And Play'},
      {key: 'no_encryption', caption: 'No Encryption'},
      {key: 'sd_card', caption: 'Sd Card'},
      {key: 'phone_missed', caption: 'Phone Missed'},
      {key: 'airline_seat_recline_extra', caption: 'Airline Seat Recline Extra'},
      {key: 'imagesearch_roller', caption: 'Imagesearch Roller'},
      {key: 'mms', caption: 'Mms'},
      {key: 'disc_full', caption: 'Disc Full'},
      {key: 'no_encryption_gmailerrorred', caption: 'No Encryption Gmailerrorred'},
      {key: 'sync_lock', caption: 'Sync Lock'},
      {key: 'bluetooth_audio', caption: 'Bluetooth Audio'},
      {key: 'sd_card_alert', caption: 'Sd Card Alert'},
      {key: 'sim_card_alert', caption: 'Sim Card Alert'},
      {key: 'do_not_disturb_off', caption: 'Do Not Disturb Off'},
      {key: 'phone_paused', caption: 'Phone Paused'},
      {key: 'airline_seat_individual_suite', caption: 'Airline Seat Individual Suite'},
      {key: 'do_disturb_off', caption: 'Do Disturb Off'},
      {key: 'phone_locked', caption: 'Phone Locked'},
      {key: 'network_locked', caption: 'Network Locked'},
      {key: 'airline_seat_flat', caption: 'Airline Seat Flat'},
      {key: 'tv_off', caption: 'Tv Off'},
      {key: 'phone_bluetooth_speaker', caption: 'Phone Bluetooth Speaker'},
      {key: 'airline_seat_flat_angled', caption: 'Airline Seat Flat Angled'},
      {key: 'airline_seat_legroom_normal', caption: 'Airline Seat Legroom Normal'},
      {key: 'directions_off', caption: 'Directions Off'},
      {key: 'airline_seat_legroom_extra', caption: 'Airline Seat Legroom Extra'},
      {key: 'airline_seat_legroom_reduced', caption: 'Airline Seat Legroom Reduced'},
      {
        key: 'video_chat',
        caption: 'Video Chat',
      },
    ],
  },
  {
    group: 'Editor',
    icons: [
      {key: 'attach_money', caption: 'Attach Money'},
      {key: 'edit_note', caption: 'Edit Note'},
      {key: 'format_list_bulleted', caption: 'Format List Bulleted'},
      {key: 'mode_edit', caption: 'Mode Edit'},
      {key: 'monetization_on', caption: 'Monetization On'},
      {key: 'attach_file', caption: 'Attach File'},
      {key: 'post_add', caption: 'Post Add'},
      {key: 'bar_chart', caption: 'Bar Chart'},
      {key: 'checklist', caption: 'Checklist'},
      {key: 'drag_handle', caption: 'Drag Handle'},
      {key: 'show_chart', caption: 'Show Chart'},
      {key: 'insert_drive_file', caption: 'Insert Drive File'},
      {key: 'format_quote', caption: 'Format Quote'},
      {key: 'query_stats', caption: 'Query Stats'},
      {key: 'format_list_numbered', caption: 'Format List Numbered'},
      {key: 'table_chart', caption: 'Table Chart'},
      {key: 'border_color', caption: 'Border Color'},
      {key: 'pie_chart', caption: 'Pie Chart'},
      {key: 'notes', caption: 'Notes'},
      {key: 'format_bold', caption: 'Format Bold'},
      {key: 'text_fields', caption: 'Text Fields'},
      {key: 'checklist_rtl', caption: 'Checklist Rtl'},
      {key: 'table_rows', caption: 'Table Rows'},
      {key: 'publish', caption: 'Publish'},
      {key: 'title', caption: 'Title'},
      {key: 'insert_emoticon', caption: 'Insert Emoticon'},
      {key: 'auto_graph', caption: 'Auto Graph'},
      {key: 'insert_photo', caption: 'Insert Photo'},
      {key: 'insert_chart_outlined', caption: 'Insert Chart Outlined'},
      {key: 'draw', caption: 'Draw'},
      {key: 'mode', caption: 'Mode'},
      {key: 'mode_comment', caption: 'Mode Comment'},
      {key: 'functions', caption: 'Functions'},
      {key: 'insert_link', caption: 'Insert Link'},
      {key: 'mode_edit_outline', caption: 'Mode Edit Outline'},
      {key: 'insert_invitation', caption: 'Insert Invitation'},
      {key: 'horizontal_rule', caption: 'Horizontal Rule'},
      {key: 'format_align_left', caption: 'Format Align Left'},
      {key: 'format_italic', caption: 'Format Italic'},
      {key: 'format_color_fill', caption: 'Format Color Fill'},
      {key: 'add_comment', caption: 'Add Comment'},
      {key: 'insert_chart', caption: 'Insert Chart'},
      {key: 'linear_scale', caption: 'Linear Scale'},
      {key: 'stacked_line_chart', caption: 'Stacked Line Chart'},
      {key: 'format_size', caption: 'Format Size'},
      {key: 'insert_comment', caption: 'Insert Comment'},
      {key: 'format_underlined', caption: 'Format Underlined'},
      {key: 'money_off', caption: 'Money Off'},
      {key: 'bubble_chart', caption: 'Bubble Chart'},
      {key: 'vertical_align_bottom', caption: 'Vertical Align Bottom'},
      {key: 'height', caption: 'Height'},
      {key: 'vertical_align_top', caption: 'Vertical Align Top'},
      {key: 'schema', caption: 'Schema'},
      {key: 'format_align_center', caption: 'Format Align Center'},
      {key: 'square', caption: 'Square'},
      {key: 'area_chart', caption: 'Area Chart'},
      {key: 'format_paint', caption: 'Format Paint'},
      {key: 'format_color_text', caption: 'Format Color Text'},
      {key: 'format_align_right', caption: 'Format Align Right'},
      {key: 'scatter_plot', caption: 'Scatter Plot'},
      {key: 'format_list_numbered_rtl', caption: 'Format List Numbered Rtl'},
      {key: 'highlight', caption: 'Highlight'},
      {key: 'format_align_justify', caption: 'Format Align Justify'},
      {key: 'data_object', caption: 'Data Object'},
      {key: 'merge_type', caption: 'Merge Type'},
      {key: 'add_chart', caption: 'Add Chart'},
      {key: 'numbers', caption: 'Numbers'},
      {key: 'format_shapes', caption: 'Format Shapes'},
      {key: 'money_off_csred', caption: 'Money Off Csred'},
      {key: 'pie_chart_outline', caption: 'Pie Chart Outline'},
      {key: 'format_indent_increase', caption: 'Format Indent Increase'},
      {key: 'short_text', caption: 'Short Text'},
      {key: 'move_up', caption: 'Move Up'},
      {key: 'strikethrough_s', caption: 'Strikethrough S'},
      {key: 'format_color_reset', caption: 'Format Color Reset'},
      {key: 'vertical_align_center', caption: 'Vertical Align Center'},
      {key: 'align_horizontal_left', caption: 'Align Horizontal Left'},
      {key: 'hexagon', caption: 'Hexagon'},
      {key: 'rectangle', caption: 'Rectangle'},
      {key: 'multiline_chart', caption: 'Multiline Chart'},
      {key: 'move_down', caption: 'Move Down'},
      {key: 'score', caption: 'Score'},
      {key: 'border_all', caption: 'Border All'},
      {key: 'text_increase', caption: 'Text Increase'},
      {key: 'format_indent_decrease', caption: 'Format Indent Decrease'},
      {key: 'polyline', caption: 'Polyline'},
      {key: 'format_clear', caption: 'Format Clear'},
      {key: 'space_bar', caption: 'Space Bar'},
      {key: 'format_line_spacing', caption: 'Format Line Spacing'},
      {key: 'horizontal_distribute', caption: 'Horizontal Distribute'},
      {key: 'align_vertical_bottom', caption: 'Align Vertical Bottom'},
      {key: 'candlestick_chart', caption: 'Candlestick Chart'},
      {key: 'align_horizontal_center', caption: 'Align Horizontal Center'},
      {key: 'vertical_distribute', caption: 'Vertical Distribute'},
      {key: 'align_horizontal_right', caption: 'Align Horizontal Right'},
      {key: 'format_strikethrough', caption: 'Format Strikethrough'},
      {key: 'superscript', caption: 'Superscript'},
      {key: 'margin', caption: 'Margin'},
      {key: 'data_array', caption: 'Data Array'},
      {key: 'pentagon', caption: 'Pentagon'},
      {key: 'wrap_text', caption: 'Wrap Text'},
      {key: 'align_vertical_top', caption: 'Align Vertical Top'},
      {key: 'border_clear', caption: 'Border Clear'},
      {key: 'subscript', caption: 'Subscript'},
      {key: 'align_vertical_center', caption: 'Align Vertical Center'},
      {key: 'text_decrease', caption: 'Text Decrease'},
      {key: 'border_style', caption: 'Border Style'},
      {key: 'padding', caption: 'Padding'},
      {key: 'border_outer', caption: 'Border Outer'},
      {key: 'line_axis', caption: 'Line Axis'},
      {key: 'insert_page_break', caption: 'Insert Page Break'},
      {key: 'border_inner', caption: 'Border Inner'},
      {key: 'border_left', caption: 'Border Left'},
      {key: 'format_textdirection_l_to_r', caption: 'Format Textdirection L To R'},
      {key: 'border_bottom', caption: 'Border Bottom'},
      {key: 'border_vertical', caption: 'Border Vertical'},
      {key: 'shape_line', caption: 'Shape Line'},
      {key: 'border_horizontal', caption: 'Border Horizontal'},
      {key: 'format_textdirection_r_to_l', caption: 'Format Textdirection R To L'},
      {key: 'border_top', caption: 'Border Top'},
      {key: 'border_right', caption: 'Border Right'},
      {
        key: 'type_specimen',
        caption: 'Type Specimen',
      },
    ],
  },
  {
    group: 'Hardware',
    icons: [
      {key: 'keyboard_arrow_down', caption: 'Keyboard Arrow Down'},
      {key: 'phone_iphone', caption: 'Phone iPhone'},
      {key: 'smartphone', caption: 'Smartphone'},
      {key: 'keyboard_arrow_right', caption: 'Keyboard Arrow Right'},
      {key: 'computer', caption: 'Computer'},
      {key: 'security', caption: 'Security'},
      {key: 'desktop_windows', caption: 'Desktop Windows'},
      {key: 'smart_display', caption: 'Smart Display'},
      {key: 'keyboard_backspace', caption: 'Keyboard Backspace'},
      {key: 'phone_android', caption: 'Phone Android'},
      {key: 'keyboard_arrow_up', caption: 'Keyboard Arrow Up'},
      {key: 'keyboard_double_arrow_right', caption: 'Keyboard Double Arrow Right'},
      {key: 'keyboard_return', caption: 'Keyboard Return'},
      {key: 'laptop', caption: 'Laptop'},
      {key: 'smart_toy', caption: 'Smart Toy'},
      {key: 'keyboard_arrow_left', caption: 'Keyboard Arrow Left'},
      {key: 'headphones', caption: 'Headphones'},
      {key: 'memory', caption: 'Memory'},
      {key: 'keyboard', caption: 'Keyboard'},
      {key: 'point_of_sale', caption: 'Point Of Sale'},
      {key: 'headset_mic', caption: 'Headset Mic'},
      {key: 'tv', caption: 'Tv'},
      {key: 'keyboard_double_arrow_left', caption: 'Keyboard Double Arrow Left'},
      {key: 'keyboard_double_arrow_down', caption: 'Keyboard Double Arrow Down'},
      {key: 'mouse', caption: 'Mouse'},
      {key: 'keyboard_voice', caption: 'Keyboard Voice'},
      {key: 'developer_board', caption: 'Developer Board'},
      {key: 'router', caption: 'Router'},
      {key: 'videogame_asset', caption: 'Videogame Asset'},
      {key: 'start', caption: 'Start'},
      {key: 'keyboard_double_arrow_up', caption: 'Keyboard Double Arrow Up'},
      {key: 'cast_for_education', caption: 'Cast For Education'},
      {key: 'device_hub', caption: 'Device Hub'},
      {key: 'headset', caption: 'Headset'},
      {key: 'laptop_mac', caption: 'Laptop Mac'},
      {key: 'cast', caption: 'Cast'},
      {key: 'watch', caption: 'Watch'},
      {key: 'tablet_mac', caption: 'Tablet Mac'},
      {key: 'devices_other', caption: 'Devices Other'},
      {key: 'desktop_mac', caption: 'Desktop Mac'},
      {key: 'keyboard_tab', caption: 'Keyboard Tab'},
      {key: 'laptop_chromebook', caption: 'Laptop Chromebook'},
      {key: 'phonelink', caption: 'Phonelink'},
      {key: 'monitor', caption: 'Monitor'},
      {key: 'speaker', caption: 'Speaker'},
      {key: 'toys', caption: 'Toys'},
      {key: 'gamepad', caption: 'Gamepad'},
      {key: 'sim_card', caption: 'Sim Card'},
      {key: 'keyboard_alt', caption: 'Keyboard Alt'},
      {key: 'connected_tv', caption: 'Connected Tv'},
      {key: 'tablet_android', caption: 'Tablet Android'},
      {key: 'cast_connected', caption: 'Cast Connected'},
      {key: 'laptop_windows', caption: 'Laptop Windows'},
      {key: 'device_unknown', caption: 'Device Unknown'},
      {key: 'browser_updated', caption: 'Browser Updated'},
      {key: 'keyboard_hide', caption: 'Keyboard Hide'},
      {key: 'scanner', caption: 'Scanner'},
      {key: 'tablet', caption: 'Tablet'},
      {key: 'speaker_group', caption: 'Speaker Group'},
      {key: 'earbuds', caption: 'Earbuds'},
      {key: 'keyboard_capslock', caption: 'Keyboard Capslock'},
      {key: 'headset_off', caption: 'Headset Off'},
      {key: 'keyboard_command_key', caption: 'Keyboard Command Key'},
      {key: 'home_max', caption: 'Home Max'},
      {key: 'headphones_battery', caption: 'Headphones Battery'},
      {key: 'power_input', caption: 'Power Input'},
      {key: 'dock', caption: 'Dock'},
      {key: 'smart_screen', caption: 'Smart Screen'},
      {key: 'browser_not_supported', caption: 'Browser Not Supported'},
      {key: 'earbuds_battery', caption: 'Earbuds Battery'},
      {key: 'phonelink_off', caption: 'Phonelink Off'},
      {key: 'home_mini', caption: 'Home Mini'},
      {key: 'adf_scanner', caption: 'Adf Scanner'},
      {key: 'developer_board_off', caption: 'Developer Board Off'},
      {key: 'videogame_asset_off', caption: 'Videogame Asset Off'},
      {key: 'keyboard_control_key', caption: 'Keyboard Control Key'},
      {key: 'watch_off', caption: 'Watch Off'},
      {
        key: 'keyboard_option_key',
        caption: 'Keyboard Option Key',
      },
    ],
  },
  {
    group: 'Device',
    icons: [
      {key: 'light_mode', caption: 'Light Mode'},
      {key: 'restart_alt', caption: 'Restart Alt'},
      {key: 'dark_mode', caption: 'Dark Mode'},
      {key: 'task', caption: 'Task'},
      {key: 'summarize', caption: 'Summarize'},
      {key: 'password', caption: 'Password'},
      {key: 'sell', caption: 'Sell'},
      {key: 'signal_cellular_alt', caption: 'Signal Cellular Alt'},
      {key: 'devices', caption: 'Devices'},
      {key: 'settings_suggest', caption: 'Settings Suggest'},
      {key: 'quiz', caption: 'Quiz'},
      {key: 'widgets', caption: 'Widgets'},
      {key: 'storage', caption: 'Storage'},
      {key: 'credit_score', caption: 'Credit Score'},
      {key: 'thermostat', caption: 'Thermostat'},
      {key: 'battery_full', caption: 'Battery Full'},
      {key: 'gps_fixed', caption: 'Gps Fixed'},
      {key: 'price_check', caption: 'Price Check'},
      {key: 'medication', caption: 'Medication'},
      {key: 'pin', caption: 'Pin'},
      {key: 'gpp_good', caption: 'Gpp Good'},
      {key: 'price_change', caption: 'Price Change'},
      {key: 'battery_charging_full', caption: 'Battery Charging Full'},
      {key: 'tungsten', caption: 'Tungsten'},
      {key: 'fmd_good', caption: 'Fmd Good'},
      {key: 'reviews', caption: 'Reviews'},
      {key: 'air', caption: 'Air'},
      {key: 'note_alt', caption: 'Note Alt'},
      {key: 'bluetooth', caption: 'Bluetooth'},
      {key: 'graphic_eq', caption: 'Graphic Eq'},
      {key: 'dvr', caption: 'Dvr'},
      {key: 'monitor_heart', caption: 'Monitor Heart'},
      {key: 'nightlight', caption: 'Nightlight'},
      {key: 'sports_score', caption: 'Sports Score'},
      {key: 'access_time', caption: 'Access Time'},
      {key: 'water', caption: 'Water'},
      {key: 'share_location', caption: 'Share Location'},
      {key: 'gpp_maybe', caption: 'Gpp Maybe'},
      {key: 'cable', caption: 'Cable'},
      {key: 'location_searching', caption: 'Location Searching'},
      {key: 'cameraswitch', caption: 'Cameraswitch'},
      {key: 'shortcut', caption: 'Shortcut'},
      {key: 'airplane_ticket', caption: 'Airplane Ticket'},
      {key: 'wallpaper', caption: 'Wallpaper'},
      {key: 'device_thermostat', caption: 'Device Thermostat'},
      {key: 'radar', caption: 'Radar'},
      {key: 'gpp_bad', caption: 'Gpp Bad'},
      {key: 'data_usage', caption: 'Data Usage'},
      {key: 'discount', caption: 'Discount'},
      {key: 'monitor_weight', caption: 'Monitor Weight'},
      {key: 'signal_wifi_4_bar', caption: 'Signal Wifi 4 Bar'},
      {key: 'developer_mode', caption: 'Developer Mode'},
      {key: 'mode_night', caption: 'Mode Night'},
      {key: 'wifi_tethering', caption: 'Wifi Tethering'},
      {key: 'battery_std', caption: 'Battery Std'},
      {key: 'bloodtype', caption: 'Bloodtype'},
      {key: 'signal_cellular_4_bar', caption: 'Signal Cellular 4 Bar'},
      {key: 'lan', caption: 'Lan'},
      {key: 'fmd_bad', caption: 'Fmd Bad'},
      {key: 'flashlight_on', caption: 'Flashlight On'},
      {key: 'splitscreen', caption: 'Splitscreen'},
      {key: 'network_wifi', caption: 'Network Wifi'},
      {key: 'sim_card_download', caption: 'Sim Card Download'},
      {key: 'access_time_filled', caption: 'Access Time Filled'},
      {key: 'airplanemode_active', caption: 'Airplanemode Active'},
      {key: 'mobile_friendly', caption: 'Mobile Friendly'},
      {key: 'usb', caption: 'Usb'},
      {key: 'send_to_mobile', caption: 'Send To Mobile'},
      {key: 'battery_alert', caption: 'Battery Alert'},
      {key: 'lens_blur', caption: 'Lens Blur'},
      {key: 'screen_search_desktop', caption: 'Screen Search Desktop'},
      {key: 'signal_wifi_statusbar_4_bar', caption: 'Signal Wifi Statusbar 4 Bar'},
      {key: 'screen_rotation', caption: 'Screen Rotation'},
      {
        key: 'signal_wifi_statusbar_connected_no_internet_4',
        caption: 'Signal Wifi Statusbar Connected No Internet 4',
      },
      {key: 'gps_not_fixed', caption: 'Gps Not Fixed'},
      {key: 'system_security_update_good', caption: 'System Security Update Good'},
      {key: 'bluetooth_connected', caption: 'Bluetooth Connected'},
      {key: 'remember_me', caption: 'Remember Me'},
      {key: 'nfc', caption: 'Nfc'},
      {key: 'mode_standby', caption: 'Mode Standby'},
      {key: 'battery_5_bar', caption: 'Battery 5 Bar'},
      {key: 'pattern', caption: 'Pattern'},
      {key: 'brightness_high', caption: 'Brightness High'},
      {key: 'battery_saver', caption: 'Battery Saver'},
      {key: 'play_lesson', caption: 'Play Lesson'},
      {key: 'storm', caption: 'Storm'},
      {key: 'data_saver_off', caption: 'Data Saver Off'},
      {key: 'data_saver_on', caption: 'Data Saver On'},
      {key: 'brightness_medium', caption: 'Brightness Medium'},
      {key: 'brightness_low', caption: 'Brightness Low'},
      {key: 'bluetooth_searching', caption: 'Bluetooth Searching'},
      {key: 'grid_4x4', caption: 'Grid 4x4'},
      {key: 'signal_wifi_0_bar', caption: 'Signal Wifi 0 Bar'},
      {key: 'screenshot', caption: 'Screenshot'},
      {key: 'network_cell', caption: 'Network Cell'},
      {key: 'mobiledata_off', caption: 'Mobiledata Off'},
      {key: 'ad_units', caption: 'Ad Units'},
      {key: 'bluetooth_disabled', caption: 'Bluetooth Disabled'},
      {key: 'ssid_chart', caption: 'Ssid Chart'},
      {key: 'battery_4_bar', caption: 'Battery 4 Bar'},
      {key: 'hdr_auto', caption: 'Hdr Auto'},
      {key: 'security_update_good', caption: 'Security Update Good'},
      {key: 'wifi_calling_3', caption: 'Wifi Calling 3'},
      {key: 'battery_0_bar', caption: 'Battery 0 Bar'},
      {key: 'battery_unknown', caption: 'Battery Unknown'},
      {key: 'signal_wifi_off', caption: 'Signal Wifi Off'},
      {key: 'settings_system_daydream', caption: 'Settings System Daydream'},
      {key: 'battery_6_bar', caption: 'Battery 6 Bar'},
      {key: 'signal_wifi_bad', caption: 'Signal Wifi Bad'},
      {key: 'access_alarms', caption: 'Access Alarms'},
      {key: 'battery_3_bar', caption: 'Battery 3 Bar'},
      {key: 'signal_wifi_connected_no_internet_4', caption: 'Signal Wifi Connected No Internet 4'},
      {key: 'aod', caption: 'Aod'},
      {key: 'access_alarm', caption: 'Access Alarm'},
      {key: 'add_to_home_screen', caption: 'Add To Home Screen'},
      {key: 'flashlight_off', caption: 'Flashlight Off'},
      {key: 'signal_cellular_0_bar', caption: 'Signal Cellular 0 Bar'},
      {key: 'security_update', caption: 'Security Update'},
      {key: 'gps_off', caption: 'Gps Off'},
      {key: 'medication_liquid', caption: 'Medication Liquid'},
      {key: 'signal_wifi_statusbar_null', caption: 'Signal Wifi Statusbar Null'},
      {key: 'battery_1_bar', caption: 'Battery 1 Bar'},
      {key: 'sd_storage', caption: 'Sd Storage'},
      {key: 'punch_clock', caption: 'Punch Clock'},
      {key: '4g_mobiledata', caption: '4g Mobiledata'},
      {key: 'grid_3x3', caption: 'Grid 3x3'},
      {key: 'reset_tv', caption: 'Reset Tv'},
      {key: 'brightness_auto', caption: 'Brightness Auto'},
      {
        key: 'signal_cellular_connected_no_internet_4_bar',
        caption: 'Signal Cellular Connected No Internet 4 Bar',
      },
      {key: 'wifi_lock', caption: 'Wifi Lock'},
      {key: 'do_not_disturb_on_total_silence', caption: 'Do Not Disturb On Total Silence'},
      {key: 'nearby_error', caption: 'Nearby Error'},
      {key: 'airplanemode_inactive', caption: 'Airplanemode Inactive'},
      {key: 'battery_2_bar', caption: 'Battery 2 Bar'},
      {key: '1x_mobiledata', caption: '1x Mobiledata'},
      {key: 'security_update_warning', caption: 'Security Update Warning'},
      {key: 'dataset', caption: 'Dataset'},
      {key: 'screenshot_monitor', caption: 'Screenshot Monitor'},
      {
        key: 'signal_cellular_connected_no_internet_0_bar',
        caption: 'Signal Cellular Connected No Internet 0 Bar',
      },
      {key: 'phishing', caption: 'Phishing'},
      {key: 'screen_lock_portrait', caption: 'Screen Lock Portrait'},
      {key: 'wifi_password', caption: 'Wifi Password'},
      {key: 'system_security_update_warning', caption: 'System Security Update Warning'},
      {key: 'system_security_update', caption: 'System Security Update'},
      {key: 'wifi_tethering_off', caption: 'Wifi Tethering Off'},
      {key: 'edgesensor_high', caption: 'Edgesensor High'},
      {key: '4g_plus_mobiledata', caption: '4g Plus Mobiledata'},
      {key: 'signal_cellular_nodata', caption: 'Signal Cellular Nodata'},
      {key: '30fps', caption: '30fps'},
      {key: 'signal_cellular_off', caption: 'Signal Cellular Off'},
      {key: 'signal_wifi_4_bar_lock', caption: 'Signal Wifi 4 Bar Lock'},
      {key: 'lte_mobiledata', caption: 'LTE Mobiledata'},
      {key: 'add_alarm', caption: 'Add Alarm'},
      {key: 'location_disabled', caption: 'Location Disabled'},
      {key: 'bluetooth_drive', caption: 'Bluetooth Drive'},
      {key: 'network_wifi_1_bar', caption: 'Network Wifi 1 Bar'},
      {key: 'mobile_off', caption: 'Mobile Off'},
      {key: 'signal_cellular_null', caption: 'Signal Cellular Null'},
      {key: 'wifi_find', caption: 'Wifi Find'},
      {key: 'media_bluetooth_on', caption: 'Media Bluetooth On'},
      {key: 'network_wifi_3_bar', caption: 'Network Wifi 3 Bar'},
      {key: 'rsvp', caption: 'Rsvp'},
      {key: 'edgesensor_low', caption: 'Edgesensor Low'},
      {key: '3g_mobiledata', caption: '3g Mobiledata'},
      {key: 'grid_goldenratio', caption: 'Grid Goldenratio'},
      {key: 'usb_off', caption: 'Usb Off'},
      {key: 'screen_lock_rotation', caption: 'Screen Lock Rotation'},
      {key: '60fps', caption: '60fps'},
      {key: 'screen_lock_landscape', caption: 'Screen Lock Landscape'},
      {key: 'lte_plus_mobiledata', caption: 'LTE Plus Mobiledata'},
      {key: 'network_wifi_2_bar', caption: 'Network Wifi 2 Bar'},
      {key: 'timer_10_select', caption: 'Timer 10 Select'},
      {key: 'wifi_2_bar', caption: 'Wifi 2 Bar'},
      {key: 'signal_cellular_no_sim', caption: 'Signal Cellular No Sim'},
      {key: 'signal_cellular_alt_1_bar', caption: 'Signal Cellular Alt 1 Bar'},
      {key: 'wifi_tethering_error', caption: 'Wifi Tethering Error'},
      {key: 'signal_cellular_alt_2_bar', caption: 'Signal Cellular Alt 2 Bar'},
      {key: 'dataset_linked', caption: 'Dataset Linked'},
      {key: 'g_mobiledata', caption: 'G Mobiledata'},
      {key: 'wifi_1_bar', caption: 'Wifi 1 Bar'},
      {key: 'wifi_channel', caption: 'Wifi Channel'},
      {key: 'timer_3_select', caption: 'Timer 3 Select'},
      {key: 'h_mobiledata', caption: 'H Mobiledata'},
      {key: 'media_bluetooth_off', caption: 'Media Bluetooth Off'},
      {key: 'e_mobiledata', caption: 'E Mobiledata'},
      {key: 'r_mobiledata', caption: 'R Mobiledata'},
      {key: 'h_plus_mobiledata', caption: 'H Plus Mobiledata'},
      {key: 'hdr_on_select', caption: 'Hdr On Select'},
      {key: 'hdr_auto_select', caption: 'Hdr Auto Select'},
      {key: 'nearby_off', caption: 'Nearby Off'},
      {key: 'hdr_off_select', caption: 'Hdr Off Select'},
      {key: 'devices_fold', caption: 'Devices Fold'},
      {key: 'fluorescent', caption: 'Fluorescent'},
      {
        key: 'macro_off',
        caption: 'Macro Off',
      },
    ],
  },
  {
    group: 'Places',
    icons: [
      {key: 'storefront', caption: 'Storefront'},
      {key: 'apartment', caption: 'Apartment'},
      {key: 'fitness_center', caption: 'Fitness Center'},
      {key: 'business_center', caption: 'Business Center'},
      {key: 'spa', caption: 'Spa'},
      {key: 'meeting_room', caption: 'Meeting Room'},
      {key: 'house', caption: 'House'},
      {key: 'corporate_fare', caption: 'Corporate Fare'},
      {key: 'ac_unit', caption: 'Ac Unit'},
      {key: 'cottage', caption: 'Cottage'},
      {key: 'family_restroom', caption: 'Family Restroom'},
      {key: 'checkroom', caption: 'Checkroom'},
      {key: 'other_houses', caption: 'Other Houses'},
      {key: 'all_inclusive', caption: 'All Inclusive'},
      {key: 'grass', caption: 'Grass'},
      {key: 'airport_shuttle', caption: 'Airport Shuttle'},
      {key: 'child_care', caption: 'Child Care'},
      {key: 'beach_access', caption: 'Beach Access'},
      {key: 'pool', caption: 'Pool'},
      {key: 'kitchen', caption: 'Kitchen'},
      {key: 'casino', caption: 'Casino'},
      {key: 'holiday_village', caption: 'Holiday Village'},
      {key: 'room_service', caption: 'Room Service'},
      {key: 'roofing', caption: 'Roofing'},
      {key: 'room_preferences', caption: 'Room Preferences'},
      {key: 'sports_bar', caption: 'Sports Bar'},
      {key: 'free_breakfast', caption: 'Free Breakfast'},
      {key: 'bathtub', caption: 'Bathtub'},
      {key: 'escalator_warning', caption: 'Escalator Warning'},
      {key: 'child_friendly', caption: 'Child Friendly'},
      {key: 'foundation', caption: 'Foundation'},
      {key: 'food_bank', caption: 'Food Bank'},
      {key: 'gite', caption: 'Gite'},
      {key: 'villa', caption: 'Villa'},
      {key: 'night_shelter', caption: 'Night Shelter'},
      {key: 'golf_course', caption: 'Golf Course'},
      {key: 'no_photography', caption: 'No Photography'},
      {key: 'stairs', caption: 'Stairs'},
      {key: 'microwave', caption: 'Microwave'},
      {key: 'backpack', caption: 'Backpack'},
      {key: 'elevator', caption: 'Elevator'},
      {key: 'wash', caption: 'Wash'},
      {key: 'smoking_rooms', caption: 'Smoking Rooms'},
      {key: 'cabin', caption: 'Cabin'},
      {key: 'house_siding', caption: 'House Siding'},
      {key: 'hot_tub', caption: 'Hot Tub'},
      {key: 'countertops', caption: 'Countertops'},
      {key: 'water_damage', caption: 'Water Damage'},
      {key: 'fire_extinguisher', caption: 'Fire Extinguisher'},
      {key: 'carpenter', caption: 'Carpenter'},
      {key: 'charging_station', caption: 'Charging Station'},
      {key: 'rv_hookup', caption: 'Rv Hookup'},
      {key: 'baby_changing_station', caption: 'Baby Changing Station'},
      {key: 'soap', caption: 'Soap'},
      {key: 'smoke_free', caption: 'Smoke Free'},
      {key: 'umbrella', caption: 'Umbrella'},
      {key: 'tapas', caption: 'Tapas'},
      {key: 'do_not_touch', caption: 'Do Not Touch'},
      {key: 'rice_bowl', caption: 'Rice Bowl'},
      {key: 'tty', caption: 'Tty'},
      {key: 'balcony', caption: 'Balcony'},
      {key: 'fence', caption: 'Fence'},
      {key: 'no_food', caption: 'No Food'},
      {key: 'houseboat', caption: 'Houseboat'},
      {key: 'bento', caption: 'Bento'},
      {key: 'wheelchair_pickup', caption: 'Wheelchair Pickup'},
      {key: 'iron', caption: 'Iron'},
      {key: 'bungalow', caption: 'Bungalow'},
      {key: 'crib', caption: 'Crib'},
      {key: 'chalet', caption: 'Chalet'},
      {key: 'do_not_step', caption: 'Do Not Step'},
      {key: 'no_meeting_room', caption: 'No Meeting Room'},
      {key: 'escalator', caption: 'Escalator'},
      {key: 'dry', caption: 'Dry'},
      {key: 'stroller', caption: 'Stroller'},
      {key: 'no_drinks', caption: 'No Drinks'},
      {key: 'no_cell', caption: 'No Cell'},
      {key: 'no_flash', caption: 'No Flash'},
      {key: 'no_backpack', caption: 'No Backpack'},
      {key: 'no_stroller', caption: 'No Stroller'},
      {key: 'vaping_rooms', caption: 'Vaping Rooms'},
      {key: 'desk', caption: 'Desk'},
      {
        key: 'vape_free',
        caption: 'Vape Free',
      },
    ],
  },
  {
    group: 'Search',
    icons: [
      {key: 'manage_search', caption: 'Manage Search'},
      {key: 'feed', caption: 'Feed'},
      {key: 'chair', caption: 'Chair'},
      {key: 'bed', caption: 'Bed'},
      {key: 'podcasts', caption: 'Podcasts'},
      {key: 'coffee', caption: 'Coffee'},
      {key: 'shower', caption: 'Shower'},
      {key: 'yard', caption: 'Yard'},
      {key: 'window', caption: 'Window'},
      {key: 'light', caption: 'Light'},
      {key: 'door_front', caption: 'Door Front'},
      {key: 'garage', caption: 'Garage'},
      {key: 'dining', caption: 'Dining'},
      {key: 'flatware', caption: 'Flatware'},
      {key: 'coffee_maker', caption: 'Coffee Maker'},
      {key: 'blender', caption: 'Blender'},
      {key: 'table_restaurant', caption: 'Table Restaurant'},
      {key: 'bedroom_parent', caption: 'Bedroom Parent'},
      {key: 'camera_indoor', caption: 'Camera Indoor'},
      {key: 'bedroom_baby', caption: 'Bedroom Baby'},
      {key: 'bathroom', caption: 'Bathroom'},
      {key: 'chair_alt', caption: 'Chair Alt'},
      {key: 'door_sliding', caption: 'Door Sliding'},
      {key: 'camera_outdoor', caption: 'Camera Outdoor'},
      {key: 'door_back', caption: 'Door Back'},
      {key: 'living', caption: 'Living'},
      {key: 'doorbell', caption: 'Doorbell'},
      {key: 'bedroom_child', caption: 'Bedroom Child'},
      {
        key: 'table_bar',
        caption: 'Table Bar',
      },
    ],
  },
  {
    group: 'Home',
    icons: [
      {key: 'sensor_door', caption: 'Sensor Door'},
      {key: 'electric_bolt', caption: 'Electric Bolt'},
      {key: 'sensor_window', caption: 'Sensor Window'},
      {key: 'energy_savings_leaf', caption: 'Energy Savings Leaf'},
      {key: 'solar_power', caption: 'Solar Power'},
      {key: 'auto_mode', caption: 'Auto Mode'},
      {key: 'shield_moon', caption: 'Shield Moon'},
      {key: 'wind_power', caption: 'Wind Power'},
      {key: 'oil_barrel', caption: 'Oil Barrel'},
      {key: 'sensor_occupied', caption: 'Sensor Occupied'},
      {key: 'electric_meter', caption: 'Electric Meter'},
      {key: 'heat_pump', caption: 'Heat Pump'},
      {key: 'gas_meter', caption: 'Gas Meter'},
      {key: 'propane_tank', caption: 'Propane Tank'},
      {key: 'mode_fan_off', caption: 'Mode Fan Off'},
      {key: 'roller_shades', caption: 'Roller Shades'},
      {key: 'broadcast_on_personal', caption: 'Broadcast On Personal'},
      {key: 'propane', caption: 'Propane'},
      {key: 'blinds', caption: 'Blinds'},
      {key: 'roller_shades_closed', caption: 'Roller Shades Closed'},
      {key: 'blinds_closed', caption: 'Blinds Closed'},
      {key: 'curtains', caption: 'Curtains'},
      {key: 'vertical_shades', caption: 'Vertical Shades'},
      {key: 'vertical_shades_closed', caption: 'Vertical Shades Closed'},
      {key: 'broadcast_on_home', caption: 'Broadcast On Home'},
      {key: 'nest_cam_wired_stand', caption: 'Nest Cam Wired Stand'},
      {
        key: 'curtains_closed',
        caption: 'Curtains Closed',
      },
    ],
  },
];
